import React, { useEffect, useState, useMemo } from 'react';
import AdminHeaderNew from '../NewAdminPanel/Common/AdminHeader';
import AdminSideBarMnt from '../NewAdminPanel/Common/AdminSidebarMnt';
import AdminFooterNew from '../NewAdminPanel/Common/AdminFooter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import Circles from '../../assets/images/circle.png';
import axios from 'axios';
import { faEye, faPencil, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
//import { parse } from 'path-browserify';
import { 
  CentralLoginDashboard, 
  StateLoginDashboard, 
  DistrictLoginDashboard, 
  SurveyorLoginDashboard,
  FmttiDashboard,
  IcarDashboard,
  AtariDashboard,
  KVKDashboard
} from './DashboardComponents';
import { kml } from "@tmcw/togeojson";



import { use } from "react";
// Helper function to handle district codes (single or multiple)
const getDistrictCode = (sessionKey = "districtNameModel", fallbackValue = null) => {
  const districtCodeFromSession = sessionStorage.getItem(sessionKey);
  
  if (!districtCodeFromSession) {
    return fallbackValue;
  }
  
  // Check if this is scheme 16 and user has multiple districts
  const schemeCode = sessionStorage.getItem("schemeCodeModel");
  if (schemeCode === "16") {
    const multiDistrictData = sessionStorage.getItem("multiDistrict");
    if (multiDistrictData && multiDistrictData !== 'null' && multiDistrictData !== '[]') {
      try {
        const multiDistrict = JSON.parse(multiDistrictData);
        if (multiDistrict && Array.isArray(multiDistrict) && multiDistrict.length > 1) {
          const districtCodes = multiDistrict.map(district => district.districtCode).join(',');
          console.log('Scheme 16 - Multiple districts from multiDistrict:', districtCodes);
          return districtCodes;
        } else if (multiDistrict && Array.isArray(multiDistrict) && multiDistrict.length === 1) {
          // Single district from multiDistrict data
          console.log('Scheme 16 - Single district from multiDistrict:', multiDistrict[0].districtCode);
          return multiDistrict[0].districtCode;
        }
      } catch (error) {
        console.error("Error parsing multiDistrict data:", error);
      }
    }
  }
  //alert(sessionStorage.getItem("fmttiCode"));
  if (districtCodeFromSession.includes(',')) {
    // Multiple districts - return as comma-separated string
    console.log('Multiple districts detected:', districtCodeFromSession);
    return districtCodeFromSession;
  } else {
    // Single district - return as string for consistency
    console.log('Single district detected:', districtCodeFromSession);
    return districtCodeFromSession;
  }
};

const DashboardMnT = () => {
  const [surveyCountNew, setSurveyCountNew] = useState(0);
  const [userCountNew, setUserCountNew] = useState(0);
  const [crmUserCount, setCrmUserCount] = useState(0);
  const [smamUserCount, setSmamUserCount] = useState(0);
  const [usersByRole, setUsersByRole] = useState({});
  const [loading, setLoading] = useState(true);
  const [farmerCount, setFarmerCount] = useState(0);
  const [farmerDetails, setFarmerDetails] = useState([]);
  const [farmerVisible, setFarmerVisible] = useState(false);
  const [chcHistoryCount, setChcHistoryCount] = useState(0);
  const [stateCount, setStateCount] = useState(0);
  const [smamCount,setSmamCount] = useState(0);
  const [smamchcHistoryCount,setSmamchcHistoryCount] = useState(0);
  const [chcHistoryDetails, setChcHistoryDetails] = useState([]);
  const [chcHistoryVisible, setChcHistoryVisible] = useState(false);
  const [surveyorCreationCount, setSurveyorCreationCount] = useState(0);
  const [surveyorCreationDetails, setSurveyorCreationDetails] = useState([]);
  const [surveyVisible, setSurveyVisible] = useState(false);
  const [survey, setSurvey] = useState(null);   // if it's state
  const [surveyorCreationVisible, setSurveyorCreationVisible] = useState(false);
  const [currentUserRoleName, setCurrentUserRoleName] = useState('');
  const [expandedRowIndex, setExpandedRowIndex] = useState(null); 
  const [expandedRowIndexs, setExpandedRowIndexs] = useState(null); 
  const [expandedRowData, setExpandedRowData] = useState([]); // holds fetched data per row
    const [expandedRowDatas, setExpandedRowDatas] = useState([]); // holds fetched data per row
  // State for second level drill-down (State-wise details)
  const [expandedStateIndex, setExpandedStateIndex] = useState(null);
  const [expandedStateData, setExpandedStateData] = useState([]);
  // State for third level drill-down (District-wise details)
  const [expandedDistrictIndex, setExpandedDistrictIndex] = useState(null);
  const [expandedDistrictData, setExpandedDistrictData] = useState([]);
  // State for surveyor drill-down (Individual surveyor details)
  const [expandedSurveyorIndex, setExpandedSurveyorIndex] = useState(null);
  const [expandedSurveyorData, setExpandedSurveyorData] = useState([]);
    const [showAll, setShowAll] = useState(false); // state to toggle view
    const [showAllSurveyRows, setShowAllSurveyRows] = useState(false);
    const [selectedFinYear, setSelectedFinYear] = useState('All'); // state to hold selected financial year
  // State for More Info functionality
  const [userVisible, setUserVisible] = useState(false);
  const [crmVisible, setCrmVisible] = useState(false);
  const [fmttiVisible, setFmttiVisible] = useState(false);
  const [smamVisible, setSmamVisible] = useState(false);
  const [crmDemoVisible, setCrmDemoVisible] = useState(false);
  const [crmDemoCount, setCrmDemoCount] = useState(0);
  const [smamChcVisible, setSmamChcVisible] = useState(false);
  const [crmChcVisible, setCrmChcVisible] = useState(false);
  
  // State for role code 7 (FMTTI Surveyor)
  const [role7UserCount, setRole7UserCount] = useState(0);
  const [role7Details, setRole7Details] = useState([]);
  const [role7Visible, setRole7Visible] = useState(false);
  
  // State for detailed data
  const [userDetails, setUserDetails] = useState([]);
  const [crmDetails, setCrmDetails] = useState([]);
  const [fmttiDetails, setFmttiDetails] = useState([]);
  const [smamDetails, setSmamDetails] = useState([]);
  const [crmDemoDetails, setCrmDemoDetails] = useState([]);
  const [crmChcDetails, setCrmChcDetails] = useState([]);
  const [chcCount, setChcCount] = useState(0);
  const[chcCountCentral, setChcCountCentral] = useState(0);
  const[smamChcCountCentral, setSmamChcCountCentral] = useState(0);
  const[fmttiCountCentral, setFmttiCountCentral] = useState(0);
  const[crmDemoCountCentral, setCrmDemoCountCentral] = useState(0);
  const [expandedChcStateIndex, setExpandedChcStateIndex] = useState(null);
  const [expandedChcDistrictData, setExpandedChcDistrictData] = useState([]);
  const [smamChcCount, setSmamChcCount] = useState(0);
  const [smamChcDetails, setSmamChcDetails] = useState([]);
  const [expandedSmamChcStateIndex, setExpandedSmamChcStateIndex] = useState(null);
  const [expandedSmamChcDistrictData, setExpandedSmamChcDistrictData] = useState([]);
  const [fmttiCount, setFmttiCount] = useState(0);
  const [fmttiStateDetails, setFmttiStateDetails] = useState([]);
  const [expandedFmttiStateIndex, setExpandedFmttiStateIndex] = useState(null);
  const [expandedFmttiDistrictData, setExpandedFmttiDistrictData] = useState([]);
  const [crmDemoStateDetails, setCrmDemoStateDetails] = useState([]);
  const [expandedCrmDemoStateIndex, setExpandedCrmDemoStateIndex] = useState(null);
  const [expandedCrmDemoDistrictData, setExpandedCrmDemoDistrictData] = useState([]);
  // State for CRM drill-down
  const [expandedCRMIndex, setExpandedCRMIndex] = useState(null);
  const [expandedCRMData, setExpandedCRMData] = useState([]);
  // State for FMTTI drill-down
  const [expandedFMTTIIndex, setExpandedFMTTIIndex] = useState(null);
  const [expandedFMTTIData, setExpandedFMTTIData] = useState([]);
  // State for State Admin User Type drill-down
  const [expandedStateUserTypeIndex, setExpandedStateUserTypeIndex] = useState(null);
  const [expandedStateUserTypeData, setExpandedStateUserTypeData] = useState([]);
  // State for third drill-down (District details for State)
  const [expandedStateDistrictIndex, setExpandedStateDistrictIndex] = useState(null);
  const [expandedStateDistrictData, setExpandedStateDistrictData] = useState([]);
  // State for SMAM drill-down
  const [expandedSMAMIndex, setExpandedSMAMIndex] = useState(null);
  const [expandedSMAMData, setExpandedSMAMData] = useState([]);
  // State for SMAM district drill-down
  const [expandedSMAMDistrictIndex, setExpandedSMAMDistrictIndex] = useState(null);
  const [expandedSMAMDistrictData, setExpandedSMAMDistrictData] = useState([]);
  const [allStatesData, setAllStatesData] = useState([]);

   const [finYears, setFinYears] = useState(() => {
      const currentYear = new Date().getFullYear();
      const years = ["All"];
  
      // Add last 5 financial years
      for (let i = 0; i < 9; i++) {
        const startYear = currentYear - i;
        const endYear = startYear + 1;
        years.push(`${startYear}-${endYear}`);
      }
  
      return years;
    });
  useEffect(() => {
    // This page is specifically for schemeCodeModel 16 (M&T)
    fetchAllCounts();
   // alert(sessionStorage.getItem("userCodeModel"));
    // Set current user role name
    const roleCode = sessionStorage.getItem("userRoleCodeModel");
    
    
    if (roleCode) {
      setCurrentUserRoleName(getRoleName(roleCode));
    }
  }, []);

  useEffect(() => {
    const fetchStatesForMap = async () => {
      try {
        const baseUrl = process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE;
        const result = await axios(`${baseUrl}/api/states`);
        if (result.data && result.data.dataContent) {
          setAllStatesData(result.data.dataContent);
        }
      } catch (error) {
        console.error("Error fetching states list:", error);
      }
    };
    fetchStatesForMap();
  }, []);

  const stateCodeNameMap = useMemo(() => {
    const map = {};
    allStatesData.forEach(state => {
      if (state.stateCode !== undefined && state.stateName) {
        map[String(state.stateCode)] = state.stateName;
      }
    });
    return map;
  }, [allStatesData]);

  // Monitor chcCountCentral state changes
  useEffect(() => {
    console.log('chcCountCentral state changed to:', chcCountCentral);
  }, [chcCountCentral]);

  // Monitor smamChcCountCentral state changes
  useEffect(() => {
    console.log('smamChcCountCentral state changed to:', smamChcCountCentral);
  }, [smamChcCountCentral]);

  // Monitor fmttiCountCentral state changes
  useEffect(() => {
    console.log('fmttiCountCentral state changed to:', fmttiCountCentral);
  }, [fmttiCountCentral]);

  // Monitor crmDemoCountCentral state changes
  useEffect(() => {
    console.log('crmDemoCountCentral state changed to:', crmDemoCountCentral);
  }, [crmDemoCountCentral]);

  // Fetch Total Users Count
  async function fetchUsersCount() {
    try {
      const userTypeCode = sessionStorage.getItem("userTypeCodeModel");
      const userRoleCode = sessionStorage.getItem("userRoleCodeModel");
     
      
      // For central login (userRoleCode 1), use the standardized API call format
      if (userRoleCode === "1") {
        const { data } = await axios.post(
          `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarReportCount`,
          {
            "flag": "AllUsers",
            "userTypeCode": 0,
            "stateCode": 0
          },
          {
            headers: {
              'accept': '/',
              'Content-Type': 'application/json'
            }
          }
        );
        console.log("Central Users API Response:", data);
        
        if (data.success && data.dataContent) {
          const totalUsers = data.dataContent[0]?.totalUsers || data.dataContent.length;
          setUserCountNew(totalUsers);
          
          // Calculate user roles for additional insights
          const usersByRole = data.dataContent.reduce((acc, user) => {
            const roleName = user.userRoleNames || 'Unknown';
            const districtNames = user.districtNames || 'Unknown';
            acc[roleName] = (acc[roleName] || 0) + 1;
            return acc;
          }, {});
          setUsersByRole(usersByRole);
          
          // Calculate SMAM count from surveyor users
          const surveyorUsers = usersByRole['Surveyor'] || 0;
          setSmamUserCount(surveyorUsers);
          
          console.log('Total Users:', totalUsers);
          console.log('Users by Role:', usersByRole);
        }
        } else if (userRoleCode === "2") { // State Admin - use GetStateDashboarCount API
        console.log('=== CRM ADMIN USER COUNT FLOW ===');
        const stateCode = sessionStorage.getItem("stateNameModel");
        //alert(stateCode);
        console.log('State Admin - StateCode from session:', stateCode);
        
        if (!stateCode) {
          console.error('State code not found in session storage');
          setUserCountNew(0);
          return;
        }

        const apiPayload = {
          "flag": "CRMUserTyp",
          "stateCode": 0, //parseInt(sessionStorage.getItem("stateNameModel")), //parseInt(stateCode),
          "userTypeCode": 0
        };
        
        console.log('State Users API Payload:', apiPayload);

        const { data } = await axios.post(
          `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetStateDashboarCount`,
          apiPayload,
          {
            headers: {
              'accept': '*/*',
              'Content-Type': 'application/json'
            }
          }
        );
        console.log("State Users API Response:", data);
        
        if (data.success && data.dataContent && data.dataContent.length > 0) {
          // Calculate total users from all user types
          const totalUsers = data.dataContent.reduce((sum, userType) => {
            return sum + parseInt(userType.totalUsers || 0);
          }, 0);
          setUserCountNew(totalUsers);
          
          // Store individual user type counts for detailed view
          const userTypeCounts = {};
          data.dataContent.forEach(userType => {
            userTypeCounts[userType.userTypeName] = parseInt(userType.totalUsers || 0);
          });
          setUsersByRole(userTypeCounts);
          
          console.log('Total Users:', totalUsers);
          console.log('Users by Type:', userTypeCounts);
         
        } else {
          setUserCountNew(0);
          console.log('No state user data received or invalid response format');
          console.log('=== END STATE ADMIN USER COUNT FLOW (NO DATA) ===');
        }
      } else if (userRoleCode === "3") { // District Admin - use GetStateDashboarCount API
        console.log('=== DISTRICT ADMIN USER COUNT FLOW ===');
        const userCode = sessionStorage.getItem("userCodeModel");
        console.log('District Admin - UserCode from session:', userCode);
        
        if (!userCode) {
          console.error('User code not found in session storage');
          setUserCountNew(0);
          return;
        }

        // Handle multiple districts using helper function
        const districtCode = getDistrictCode("districtNameModel");
        console.log('🎯 District Admin - Using district code:', districtCode);
        console.log('🎯 District Admin - District code type:', typeof districtCode);
        const apiPayload = {
          "flag": "AllUsers",
          "userTypeCode": parseInt(sessionStorage.getItem("userTypeCodeModel")),
          "stateCode": parseInt(sessionStorage.getItem("stateNameModel")), //parseInt(stateCode),
          "districtCode": String(districtCode)
        };
        
        console.log('District Users API Payload:', apiPayload);

        const { data } = await axios.post(
          `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDistrictDashboarCount`,
          apiPayload,
          {
            headers: {
              'accept': '*/*',
              'Content-Type': 'application/json'
            }
          }
        );
        console.log("District Users API Response:", data);
        
        if (data.success && data.dataContent && data.dataContent.length > 0) {
          // Calculate total users from all user types
          const totalUsers = data.dataContent.reduce((sum, userType) => {
            return sum + parseInt(userType.totalUsers || 0);
          }, 0);
          setUserCountNew(totalUsers);
          
          // Store individual user type counts for detailed view
          const userTypeCounts = {};
          data.dataContent.forEach(userType => {
            userTypeCounts[userType.userTypeName] = parseInt(userType.totalUsers || 0);
          });
          setUsersByRole(userTypeCounts);
          
          console.log('District Total Users set to:', totalUsers);
          console.log('Users by Type:', userTypeCounts);
          console.log('=== END DISTRICT ADMIN USER COUNT FLOW ===');
        } else {
          setUserCountNew(0);
          console.log('No district user data received or invalid response format');
          console.log('=== END DISTRICT ADMIN USER COUNT FLOW (NO DATA) ===');
        }
      } else {
        // For other user types (not Central Admin, State Admin, or District Admin), use the original GET request
        // Note: ICAR Admin (role code 10) now uses IcarDashboard component which handles its own data fetching
        console.log('Using GetDashboarReportCount API for other user types (not Central, State, District, or ICAR)');
        const { data } = await axios.get(
          `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarReportCount`,
          {
            headers: {
              'accept': '*/*'
            }
          }
        );
        console.log("Users API Response:", data);
        
        if (data.success && data.dataContent) {
          const totalUsers = data.totalUsers || data.dataContent.length;
          setUserCountNew(totalUsers);
          
          // Calculate user roles for additional insights
          const usersByRole = data.dataContent.reduce((acc, user) => {
            const roleName = user.userRoleNames || 'Unknown';
            const districtNames = user.districtNames || 'Unknown';
            acc[roleName] = (acc[roleName] || 0) + 1;
            return acc;
          }, {});
          setUsersByRole(usersByRole);
          
          // Calculate SMAM count from surveyor users
          const surveyorUsers = usersByRole['Surveyor'] || 0;
          setSmamUserCount(surveyorUsers);
          
          console.log('Total Users:', totalUsers);
          console.log('Users by Role:', usersByRole);
        }
      }
    } catch (error) {
      console.error('Error fetching users count:', error);
    }
  }

  // Fetch CRM Count
  async function fetchCRMCount() {
    try {
      const { data } = await axios.get(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetCHDetailsCount`,
        {
          headers: {
            'accept': '*/*'
          }
        }
      );
      console.log("CRM API Response:", data);
      
      if (data.success) {
        // Handle the response based on the actual structure
        const crmCount = data.recordCount || data.dataContent?.length || 0;
        setCrmUserCount(crmCount);
        console.log('CRM Count:', crmCount);
      }
    } catch (error) {
      console.error('Error fetching CRM count:', error);
    }
  }

  

  // Fetch CHC History Data using GetDashboarSurveyorReportCountState API
  async function fetchCHCHistoryData() {
    try {
      const userRoleCode = sessionStorage.getItem("userRoleCodeModel");
      const stateCode = sessionStorage.getItem("stateNameModel");
      
      console.log('fetchCHCHistoryData using API: GetDashboarSurveyorReportCountState for userRoleCode:', userRoleCode);
      
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCountState`,
        {
          "flag": "CHCCount",
          "userTypeCode": 2,
          "stateCode": parseInt(stateCode)
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      if (data.success && data.dataContent) {
        setChcHistoryCount(data.recordCount || data.dataContent.length || 0);
        setChcHistoryDetails(data.dataContent || []);
      }
    } catch (error) {
      console.error('Error fetching CHC history data:', error);
      setChcHistoryCount(0);
      setChcHistoryDetails([]);
    }
  }

  // Fetch Farmer Registration Data
  // async function fetchFarmerData() {
  //   try {
  //     const createdBy = sessionStorage.getItem("userCodeModel");
  //     if (!createdBy) {
  //       console.error('User code not found in session storage');
  //       return;
  //     }

  //     const { data } = await axios.post(
  //       `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/Farmers/GetMTFarmerRegData`,
  //       {
  //         createdBy: createdBy
  //       },
  //       {
  //         headers: {
  //           'Content-Type': 'application/json'
  //         }
  //       }
  //     );

  //     if (data.success && data.dataContent) {
  //       setFarmerCount(data.recordCount || data.dataContent.length || 0);
  //       setFarmerDetails(data.dataContent || []);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching farmer registration data:', error);
  //     setFarmerCount(0);
  //     setFarmerDetails([]);
  //   }
  // }

  // Fetch Surveyor Creation Data
  async function fetchSurveyorCreationData() {
    try {
      const createdBy = sessionStorage.getItem("userCodeModel");
      if (!createdBy) {
        console.error('User code not found in session storage');
        return;
      }

      // Use the helper function to get district codes (single or multiple)
      const districtCode = getDistrictCode("districtNameModel");
      const stateCode = parseInt(sessionStorage.getItem("stateNameModel"));
      console.log('🎯 Surveyor Creation - Using district code:', districtCode);
      console.log('🎯 Surveyor Creation - Using state code:', stateCode);
      
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDistrictDashboarCount`,
        {
           "flag": "AllUsers",
           "userTypeCode": 2,
           "stateCode": stateCode, 
          "districtCode": String(districtCode)
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      if (data.success && data.dataContent) {
        // Calculate total users from all user types in dataContent
        const totalUsers = data.dataContent.reduce((sum, userType) => {
          return sum + parseInt(userType.totalUsers || 0);
        }, 0);
        setSurveyorCreationCount(totalUsers);
        setSurveyorCreationDetails(data.dataContent || []);
      }
    } catch (error) {
      console.error('Error fetching surveyor creation data:', error);
      setSurveyorCreationCount(0);
      setSurveyorCreationDetails([]);
    }
  }

  // Fetch Surveyor Creation District-wise Details
  function getDistrictCode(key) {
    const districtNameFromSession = sessionStorage.getItem(key);
    if (!districtNameFromSession) {
      return null;
    }
    if (districtNameFromSession.includes(',')) {
      const districtCodes = districtNameFromSession.split(',').map(code => code.trim());
      return districtCodes.join(',');
    }
    return districtNameFromSession;
  }

  // Fetch Surveyor Creation District-wise Details
  async function fetchSurveyorCreationDistrictDetails() {
    try {
      const districtCode = getDistrictCode("districtNameModel");
      const stateCode = parseInt(sessionStorage.getItem("stateNameModel"));
      console.log('🎯 Surveyor Creation District Details - Using district code:', districtCode);
      console.log('🎯 Surveyor Creation District Details - Using state code:', stateCode);
      
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDistrictDashboarCount`,
        {
           "flag": "District",
           "userTypeCode": sessionStorage.getItem("userTypeCodeModel"),
           "stateCode": sessionStorage.getItem("stateNameModel"), 
          "districtCode": String(districtCode)
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('Surveyor Creation District Details API Response:', data);

      if (data.success && data.dataContent) {
        setSurveyorCreationDetails(data.dataContent || []);
      } else {
        setSurveyorCreationDetails([]);
      }
    } catch (error) {
      console.error('Error fetching surveyor creation district details:', error);
      setSurveyorCreationDetails([]);
    }
  }

  // Fetch Individual Surveyor Details for a specific district
  async function fetchSurveyorDetails(districtCode) {
    try {
      const stateCode = parseInt(sessionStorage.getItem("stateNameModel"));
      console.log('🎯 Surveyor Details - Using district code:', districtCode);
      console.log('🎯 Surveyor Details - Using state code:', stateCode);
      
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDistrictDashboarCount`,
        {
           "flag": "Surveyor",
           "userTypeCode": 2,
           "stateCode": stateCode, 
          "districtCode": String(districtCode)
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('Surveyor Details API Response:', data);
      console.log('Surveyor Details dataContent structure:', data.dataContent);

      if (data.success && data.dataContent) {
        // Log the structure of each item to understand the field names
        if (data.dataContent.length > 0) {
          console.log('First surveyor item structure:', data.dataContent[0]);
          console.log('Available fields:', Object.keys(data.dataContent[0]));
        }
        return data.dataContent || [];
      } else {
        return [];
      }
    } catch (error) {
      console.error('Error fetching surveyor details:', error);
      return [];
    }
  }

  // Fetch CRM Machine Demonstration Data
  async function fetchCRMDemoData() {
    try {
      const createdBy = sessionStorage.getItem("userCodeModel");
      if (!createdBy) {
        console.error('User code not found in session storage');
        return;
      }

      console.log('🎯 CRM Machine Demo - Using createdBy:', createdBy);
      
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/Farmers/GetMTFarmerRegData`,
        {
          createdBy: parseInt(createdBy)
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('CRM Machine Demo API Response:', data);

      if (data.success && data.dataContent) {
        setCrmDemoCount(data.recordCount || data.dataContent.length || 0);
        setCrmDemoDetails(data.dataContent || []);
      } else {
        setCrmDemoCount(0);
        setCrmDemoDetails([]);
      }
    } catch (error) {
      console.error('Error fetching CRM Machine Demo data:', error);
      setCrmDemoCount(0);
      setCrmDemoDetails([]);
    }
  }
  // Handle surveyor drill-down toggle
  const handleSurveyorToggle = async (index, district) => {
    if (expandedSurveyorIndex === index) {
      setExpandedSurveyorIndex(null); // collapse
      setExpandedSurveyorData([]); // clear data when collapsing
    } else {
      setExpandedSurveyorIndex(index); // expand
      console.log('Fetching surveyor details for district:', district);
      
      try {
        const surveyorData = await fetchSurveyorDetails(district.districtCode);
        setExpandedSurveyorData(surveyorData);
        console.log('Surveyor data set:', surveyorData);
        console.log('Surveyor data length:', surveyorData.length);
        if (surveyorData.length > 0) {
          console.log('First surveyor in expanded data:', surveyorData[0]);
        }
      } catch (error) {
        console.error('Error fetching surveyor details:', error);
        setExpandedSurveyorData([]);
      }
    }
  };

  function handleViewData(userData) {
       
  }
  // Function to get role name from role code
  const getRoleName = (roleCode) => {
    const roleMap = {
      '1': 'Central Admin',
      '2': 'State Admin',
      '3': 'District Admin',
      '5': 'Surveyor',
      '6': 'FMTTI Admin',
      '9': 'CRM Admin'
    };
    return roleMap[roleCode] || 'Unknown Role';
  };

  // State count is now handled in StateLoginDashboard component

  // Fetch SMAM Count using GetDashboarSurveyorReportCountState API
  async function fetchSMAMCount() {
    try {
      const userRoleCode = sessionStorage.getItem("userRoleCodeModel");
      const stateCode = sessionStorage.getItem("stateNameModel");
      
      console.log('fetchSMAMCount using API: GetDashboarSurveyorReportCountState for userRoleCode:', userRoleCode);
      
      // Determine userTypeCode and stateCode based on user role
      let userTypeCode;
      let apiStateCode;
      
      if (userRoleCode === "1") { // Central Admin
        userTypeCode = 1;
        apiStateCode = 0; // Central admin sees all states
      } else if (userRoleCode === "2") { // State Admin
        userTypeCode = 2;
        apiStateCode = parseInt(stateCode);
      } else if (userRoleCode === "3") { // District Admin
        userTypeCode = 3;
        apiStateCode = parseInt(stateCode);
      } else {
        // Default fallback for SMAM
        userTypeCode = 3;
        apiStateCode = parseInt(stateCode);
      }
      
      const result = await axios({
        method: 'post',
        url: `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCountState`,
        headers: {
          'accept': '*/*',
          'Content-Type': 'application/json'
        },
        data: {
          "flag": "CHCCount",
          "userTypeCode": userTypeCode,
          "stateCode": apiStateCode
        }
      });

      if (result.data.success && result.data.dataContent) {
        const smamCountValue = result.data.recordCount || result.data.dataContent.length || 0;
        setSmamCount(smamCountValue);
        console.log('SMAM Count:', smamCountValue);
      }
    } catch (error) {
      console.error('Error fetching SMAM count:', error);
      setSmamCount(0);
    }
  }

  // Fetch CHC Count for Central Admin using GetDashboarSurveyorReportCount API
  async function fetchCHCCountCentral() {
    try {
      console.log('=== FETCHING CHC COUNT FOR CENTRAL ADMIN ===');
      console.log('API URL:', `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCount`);
      
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCount`,
        {
          "flag": "CHCCount",
          "userTypeCode": 2,
          "stateCode": 0
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );
      
      console.log("Central CHC Count API Response:", data);
      console.log("Response structure:", {
        success: data.success,
        recordCount: data.recordCount,
        dataContent: data.dataContent,
        total: data.total
      });
      
      if (data.success && data.total) {
        const chcCountValue = parseInt(data.total.toString()) || 0;
        setChcCountCentral(chcCountValue);
        console.log('Central CHC Count from total:', chcCountValue);
      } else if (data.success && data.dataContent && data.dataContent.length > 0) {
        const chcCountValue = parseInt(data.dataContent[0].total) || 0;
        setChcCountCentral(chcCountValue);
        console.log('Central CHC Count from dataContent total:', chcCountValue);
      } else if (data.success && data.recordCount) {
        const chcCountValue = parseInt(data.recordCount.toString()) || 0;
        setChcCountCentral(chcCountValue);
        console.log('Central CHC Count from recordCount (fallback):', chcCountValue);
      } else {
        setChcCountCentral(0);
        console.log('No Central CHC data received or invalid format');
      }
      
      console.log('Setting chcCountCentral state to:', chcCountCentral);
    } catch (error) {
      console.error('Error fetching Central CHC count:', error);
      setChcCountCentral(0);
    }
  }

  // Fetch SMAM CHC Count for Central Admin using GetDashboarSurveyorReportCount API
  async function fetchSMAMCHCCountCentral() {
    try {
      console.log('=== FETCHING SMAM CHC COUNT FOR CENTRAL ADMIN ===');
      console.log('API URL:', `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCount`);
      
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCount`,
        {
          "flag": "CHCCount",
          "userTypeCode": 3,
          "stateCode": 0
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );
      
      console.log("Central SMAM CHC Count API Response:", data);
      console.log("Response structure:", {
        success: data.success,
        recordCount: data.recordCount,
        dataContent: data.dataContent,
        total: data.total
      });
      
      if (data.success && data.total) {
        const smamChcCountValue = parseInt(data.total.toString()) || 0;
        setSmamChcCountCentral(smamChcCountValue);
        console.log('Central SMAM CHC Count from total:', smamChcCountValue);
      } else if (data.success && data.dataContent && data.dataContent.length > 0) {
        const smamChcCountValue = parseInt(data.dataContent[0].total) || 0;
        setSmamChcCountCentral(smamChcCountValue);
        console.log('Central SMAM CHC Count from dataContent total:', smamChcCountValue);
      } else if (data.success && data.recordCount) {
        const smamChcCountValue = parseInt(data.recordCount.toString()) || 0;
        setSmamChcCountCentral(smamChcCountValue);
        console.log('Central SMAM CHC Count from recordCount (fallback):', smamChcCountValue);
      } else {
        setSmamChcCountCentral(0);
        console.log('No Central SMAM CHC data received or invalid format');
      }
      
      console.log('Setting smamChcCountCentral state to:', smamChcCountCentral);
    } catch (error) {
      console.error('Error fetching Central SMAM CHC count:', error);
      setSmamChcCountCentral(0);
    }
  }

  // Fetch FMTTI Count for Central Admin using GetDashboarSurveyorReportCount API
  async function fetchFMTTICountCentral() {
    try {
      console.log('=== FETCHING FMTTI COUNT FOR CENTRAL ADMIN ===');
      console.log('API URL:', `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCount`);
      
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCount`,
        {
          "flag": "Farmer",
          "userTypeCode": 1,
          "stateCode": 0
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );
      
      console.log("Central FMTTI Count API Response:", data);
      console.log("Response structure:", {
        success: data.success,
        recordCount: data.recordCount,
        dataContent: data.dataContent,
        total: data.total
      });
      
      if (data.success && data.total) {
        const fmttiCountValue = parseInt(data.total.toString()) || 0;
        setFmttiCountCentral(fmttiCountValue);
        console.log('Central FMTTI Count from total:', fmttiCountValue);
      } else if (data.success && data.dataContent && data.dataContent.length > 0) {
        const fmttiCountValue = parseInt(data.dataContent[0].total) || 0;
        setFmttiCountCentral(fmttiCountValue);
        console.log('Central FMTTI Count from dataContent total:', fmttiCountValue);
      } else if (data.success && data.recordCount) {
        const fmttiCountValue = parseInt(data.recordCount.toString()) || 0;
        setFmttiCountCentral(fmttiCountValue);
        console.log('Central FMTTI Count from recordCount (fallback):', fmttiCountValue);
      } else {
        setFmttiCountCentral(0);
        console.log('No Central FMTTI data received or invalid format');
      }
      
      console.log('Setting fmttiCountCentral state to:', fmttiCountCentral);
    } catch (error) {
      console.error('Error fetching Central FMTTI count:', error);
      setFmttiCountCentral(0);
    }
  }

  // Fetch CRM Demo Count for Central Admin using GetDashboarSurveyorReportCount API
  async function fetchCRMDemoCountCentral() {
    try {
      console.log('=== FETCHING CRM DEMO COUNT FOR CENTRAL ADMIN ===');
      console.log('API URL:', `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCount`);
      
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCount`,
        {
          "flag": "Farmer",
          "userTypeCode": 2,
          "stateCode": 0
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );
      
      console.log("Central CRM Demo Count API Response:", data);
      console.log("Response structure:", {
        success: data.success,
        recordCount: data.recordCount,
        dataContent: data.dataContent,
        total: data.total
      });
      
      if (data.success && data.total) {
        const crmDemoCountValue = parseInt(data.total.toString()) || 0;
        setCrmDemoCountCentral(crmDemoCountValue);
        console.log('Central CRM Demo Count from total:', crmDemoCountValue);
      } else if (data.success && data.dataContent && data.dataContent.length > 0) {
        const crmDemoCountValue = parseInt(data.dataContent[0].total) || 0;
        setCrmDemoCountCentral(crmDemoCountValue);
        console.log('Central CRM Demo Count from dataContent total:', crmDemoCountValue);
      } else if (data.success && data.recordCount) {
        const crmDemoCountValue = parseInt(data.recordCount.toString()) || 0;
        setCrmDemoCountCentral(crmDemoCountValue);
        console.log('Central CRM Demo Count from recordCount (fallback):', crmDemoCountValue);
      } else {
        setCrmDemoCountCentral(0);
        console.log('No Central CRM Demo data received or invalid format');
      }
      
      console.log('Setting crmDemoCountCentral state to:', crmDemoCountCentral);
    } catch (error) {
      console.error('Error fetching Central CRM Demo count:', error);
      setCrmDemoCountCentral(0);
    }
  }

  // Fetch CHC Count using GetDashboarSurveyorReportCount API
  async function fetchCHCCount() {
    try {
      const userRoleCode = sessionStorage.getItem("userRoleCodeModel");
      const stateCode = sessionStorage.getItem("stateNameModel");
      
      console.log('=== DEBUGGING CHC COUNT API ===');
      console.log('fetchCHCCount called for userRoleCode:', userRoleCode);
      console.log('fetchCHCCount stateCode from session:', stateCode);
      console.log('All session storage keys:', Object.keys(sessionStorage));
      console.log('userRoleCodeModel value:', sessionStorage.getItem("userRoleCodeModel"));
      console.log('userTypeCodeModel value:', sessionStorage.getItem("userTypeCodeModel"));
      console.log('stateNameModel value:', sessionStorage.getItem("stateNameModel"));
      console.log('================================');
      
      // Determine userTypeCode based on user role
      let userTypeCode;
      let apiStateCode;
      
      if (userRoleCode === "1") { // Central Admin
        userTypeCode = 1;
        apiStateCode = 0; // Central admin sees all states
      } else if (userRoleCode === "2") { // State Admin
        userTypeCode = 2;
        apiStateCode = parseInt(stateCode);
      } else if (userRoleCode === "3") { // District Admin
        userTypeCode = 3;
        apiStateCode = parseInt(stateCode);
      } else {
        // Default fallback
        userTypeCode = 2;
        apiStateCode = userRoleCode === "2" ? parseInt(stateCode) : 0;
      }
      
      const apiPayload = {
        "flag": "CHCCount",
        "userTypeCode": userTypeCode,
        "stateCode": apiStateCode
      };
      
      console.log('CHC Count API Payload:', apiPayload);
      console.log('Final userTypeCode being sent:', userTypeCode);
      console.log('Final stateCode being sent:', apiStateCode);
      
      console.log('fetchCHCCount using API: GetDashboarSurveyorReportCountState for userRoleCode:', userRoleCode);
      
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCountState`,
        apiPayload,
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );
      
      console.log("CHC Count API Response:", data);
      
      if (data.success && data.recordCount) {
        // Handle case where recordCount is at root level - this is the primary source
        const chcCountValue = parseInt(data.recordCount.toString()) || 0;
        setChcCount(chcCountValue);
        console.log('CHC Count from recordCount:', chcCountValue);
      } else if (data.success && data.dataContent && data.dataContent.length > 0) {
        // Parse the count value - check for total, recordCount, or other count fields
        const totalValue = data.dataContent[0].total || data.dataContent[0].count || data.recordCount || 0;
        const chcCountValue = totalValue ? parseInt(totalValue.toString()) : 0;
        setChcCount(chcCountValue);
        console.log('CHC Count:', chcCountValue, 'from totalValue:', totalValue);
      } else {
        setChcCount(0);
        console.log('No CHC data received or invalid format');
      }
    } catch (error) {
      console.error('Error fetching CHC count:', error);
      setChcCount(0);
    }
  }

  // Fetch SMAM CHC Count using GetDashboarSurveyorReportCountState API for state login
  async function fetchSMAMCHCCount() {
    try {
      const userRoleCode = sessionStorage.getItem("userRoleCodeModel");
      const stateCode = sessionStorage.getItem("stateNameModel");
      
      console.log('fetchSMAMCHCCount using API: GetDashboarSurveyorReportCountState for userRoleCode:', userRoleCode);
      
      // Determine userTypeCode and stateCode based on user role
      let userTypeCode;
      let apiStateCode;
      
      if (userRoleCode === "1") { // Central Admin
        userTypeCode = 1;
        apiStateCode = 0; // Central admin sees all states
      } else if (userRoleCode === "2") { // State Admin
        userTypeCode = 2;
        apiStateCode = parseInt(stateCode);
      } else if (userRoleCode === "3") { // District Admin
        userTypeCode = 3;
        apiStateCode = parseInt(stateCode);
      } else {
        // Default fallback for SMAM CHC
        userTypeCode = 3;
        apiStateCode = parseInt(stateCode);
      }
      
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCountState`,
        {
          "flag": "CHCCount",
          "userTypeCode": userTypeCode,
          "stateCode": apiStateCode
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );
      
      console.log("SMAM CHC Count API Response:", data);
      
      if (data.success && data.recordCount) {
        // Handle case where recordCount is at root level - this is the primary source
        const smamChcCountValue = parseInt(data.recordCount.toString()) || 0;
        setSmamChcCount(smamChcCountValue);
        setSmamchcHistoryCount(smamChcCountValue);
        console.log('SMAM CHC Count from recordCount:', smamChcCountValue);
      } else if (data.success && data.dataContent && data.dataContent.length > 0) {
        // Parse the count value - check for total, recordCount, or other count fields
        const totalValue = data.dataContent[0].total || data.dataContent[0].count || data.recordCount || 0;
        const smamChcCountValue = totalValue ? parseInt(totalValue.toString()) : 0;
        setSmamChcCount(smamChcCountValue);
        setSmamchcHistoryCount(smamChcCountValue); // Also set the history count for the card display
        console.log('SMAM CHC Count:', smamChcCountValue, 'from totalValue:', totalValue);
      } else {
        setSmamChcCount(0);
        setSmamchcHistoryCount(0); // Also reset the history count
        console.log('No SMAM CHC data received or invalid format');
      }
    } catch (error) {
      console.error('Error fetching SMAM CHC count:', error);
      setSmamChcCount(0);
      setSmamchcHistoryCount(0); // Also reset the history count on error
    }
  }

  // Fetch FMTTI Count using GetDashboarSurveyorReportCountState API for state login
  async function fetchFMTTICount() {
    try {
      const userRoleCode = sessionStorage.getItem("userRoleCodeModel");
      
      console.log('fetchFMTTICount using API: GetDashboarSurveyorReportCountState for userRoleCode:', userRoleCode);
      
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCountState`,
        {
          "flag": "Farmer",
          "userTypeCode": 1,
          "stateCode": userRoleCode === "2" ? parseInt(sessionStorage.getItem("stateNameModel")) : 0
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );
      
      console.log("FMTTI Count API Response:", data);
      
      if (data.success && data.recordCount) {
        // Handle case where recordCount is at root level - this is the primary source
        const fmttiCountValue = parseInt(data.recordCount.toString()) || 0;
        setFmttiCount(fmttiCountValue);
        console.log('FMTTI Count from recordCount:', fmttiCountValue);
      } else if (data.success && data.dataContent && data.dataContent.length > 0) {
        // Parse the count value - check for totalFarmers, total, recordCount, or other count fields
        const totalValue = data.dataContent[0].totalFarmers || data.dataContent[0].total || data.dataContent[0].count || data.recordCount || 0;
        const fmttiCountValue = totalValue ? parseInt(totalValue.toString()) : 0;
        setFmttiCount(fmttiCountValue);
        console.log('FMTTI Count:', fmttiCountValue, 'from totalValue:', totalValue);
      } else {
        setFmttiCount(0);
        console.log('No FMTTI data received or invalid format');
      }
    } catch (error) {
      console.error('Error fetching FMTTI count:', error);
      setFmttiCount(0);
    }
  }

  // Fetch CRM Demo Count using GetDashboarSurveyorReportCountState API for state login
  async function fetchCRMDemoCount() {
    try {
      const userRoleCode = sessionStorage.getItem("userRoleCodeModel");
      const stateCode = sessionStorage.getItem("stateNameModel");
      
      console.log('fetchCRMDemoCount using API: GetDashboarSurveyorReportCountState for userRoleCode:', userRoleCode);
      
      // Determine userTypeCode and stateCode based on user role
      let userTypeCode;
      let apiStateCode;
      
      if (userRoleCode === "1") { // Central Admin
        userTypeCode = 1;
        apiStateCode = 0; // Central admin sees all states
      } else if (userRoleCode === "2") { // State Admin
        userTypeCode = 2;
        apiStateCode = parseInt(stateCode);
      } else if (userRoleCode === "3") { // District Admin
        userTypeCode = 3;
        apiStateCode = parseInt(stateCode);
      } else {
        // Default fallback
        userTypeCode = 2;
        apiStateCode = userRoleCode === "2" ? parseInt(stateCode) : 0;
      }
      
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCountState`,
        {
          "flag": "Farmer",
          "userTypeCode": userTypeCode,
          "stateCode": apiStateCode
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );
      
      console.log("CRM Demo Count API Response:", data);
      
      if (data.success && data.recordCount) {
        // Handle case where recordCount is at root level - this is the primary source
        const crmDemoCountValue = parseInt(data.recordCount.toString()) || 0;
        setCrmDemoCount(crmDemoCountValue);
        console.log('CRM Demo Count from recordCount:', crmDemoCountValue);
      } else if (data.success && data.dataContent && data.dataContent.length > 0) {
        // Parse the count value - check for totalFarmers, total, recordCount, or other count fields
        const totalValue = data.dataContent[0].totalFarmers || data.dataContent[0].total || data.dataContent[0].count || data.recordCount || 0;
        const crmDemoCountValue = totalValue ? parseInt(totalValue.toString()) : 0;
        setCrmDemoCount(crmDemoCountValue);
        console.log('CRM Demo Count:', crmDemoCountValue, 'from totalValue:', totalValue);
      } else {
        setCrmDemoCount(0);
        console.log('No CRM Demo data received or invalid format');
      }
    } catch (error) {
      console.error('Error fetching CRM Demo count:', error);
      setCrmDemoCount(0);
    }
  }

  // Fetch Role Code 7 (FMTTI Surveyor) Data
  async function fetchRole7Data() {
    try {
      const fmttiCode = sessionStorage.getItem("fmttiCode");
      console.log('Fetching Role 7 data with fmttiCode:', fmttiCode);
      
      if (!fmttiCode) {
        console.error('FMTTI Code not found in session storage');
        setRole7UserCount(0);
        setRole7Details([]);
        return;
      }

      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetFMTTIDashboarReportCount`,
        {
          "flag": "Surveyor",
          "fmttiCode": sessionStorage.getItem("fmttiCode") //parseInt(fmttiCode) || 1
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('Role 7 API Response:', data);

      if (data.success && data.dataContent) {
        const userCount = data.recordCount || data.dataContent.length || 0;
        setRole7UserCount(userCount);
        setRole7Details(Array.isArray(data.dataContent) ? data.dataContent : []);
        console.log('Role 7 User Count:', userCount);
      } else {
        setRole7UserCount(0);
        setRole7Details([]);
        console.log('Role 7 API returned success: false or no data');
      }
    } catch (error) {
      console.error('Error fetching Role 7 data:', error);
      setRole7UserCount(0);
      setRole7Details([]);
    }
  }

  // Fetch all counts
  async function fetchAllCounts() {
    setLoading(true);
    try {
      const userRoleCode = sessionStorage.getItem("userRoleCodeModel");
      console.log('fetchAllCounts called for userRoleCode:', userRoleCode);
      
      const baseFunctions = [];

      // Only fetch central admin data if user is central admin
      if (userRoleCode === "1") {
        baseFunctions.push(
          fetchUsersCount(),
          fetchCHCCountCentral(),
          fetchSMAMCHCCountCentral(),
          fetchFMTTICountCentral(),
          fetchCRMDemoCountCentral()
        );
      }
      
      // Note: ICAR admin (role code 10) now uses IcarDashboard component which handles its own data fetching
      
      // Add role-specific functions
      if (userRoleCode === "5" || userRoleCode ==="8" || userRoleCode==="12") { // Surveyor role
        baseFunctions.push(fetchCRMDemoData());
      }
      
      // Add role code 7 function
      if (userRoleCode === "7") {
        baseFunctions.push(fetchRole7Data());
      }
      
      console.log('Base functions to execute:', baseFunctions.length);
      console.log('Executing all functions...');
      await Promise.all(baseFunctions);
      console.log('All functions completed');
    } finally {
      setLoading(false);
    }
  }

  // Function to handle More Info clicks
  const handleMoreInfoClick = async (type, preloadedRows) => {
    try {
      // Logic to toggle the clicked div and close others
      switch (type) {
      case 'chcHistory':
        setUserVisible(false);
        setCrmVisible(false);
        setFmttiVisible(false);
        setSmamVisible(false);
        setCrmDemoVisible(false);
        setFarmerVisible(false);
        setSurveyorCreationVisible(false);
        setChcHistoryVisible(!chcHistoryVisible);
        if (!chcHistoryVisible) {
          await fetchCHCHistoryData();
          setTimeout(() => {
            const tableElement = document.getElementById('chc-history-table');
            if (tableElement) {
              tableElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }, 100);
        }
        break;
      case 'farmer':
        setUserVisible(false);
        setCrmVisible(false);
        setFmttiVisible(false);
        setSmamVisible(false);
        setCrmDemoVisible(false);
        setSurveyorCreationVisible(false);
        setFarmerVisible(!farmerVisible);
        // if (!farmerVisible) {
        //   await fetchFarmerData();
        //   setTimeout(() => {
        //     const tableElement = document.getElementById('farmer-details-table');
        //     if (tableElement) {
        //       tableElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        //     }
        //   }, 100);
        // }
        break;
      case 'user':
        setUserVisible(!userVisible);
        setCrmVisible(false);
        setFmttiVisible(false);
        setSmamVisible(false);
        setCrmDemoVisible(false);
        setFarmerVisible(false);
        setChcHistoryVisible(false);
        setSurveyorCreationVisible(false);
        if (!userVisible) {
          // If rows are provided from StateLoginDashboard, use them directly for clarity and to avoid duplicate calls
          if (Array.isArray(preloadedRows)) {
            setUserDetails(preloadedRows);
          } else {
          await fetchUserDetails();
          }
          // Auto scroll to the table after a short delay to ensure it's rendered
          setTimeout(() => {
            const tableElement = document.getElementById('user-details-table');
            if (tableElement) {
              tableElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }, 100);
        }
        break;
      case 'crm':
        setUserVisible(false);
        setCrmVisible(!crmVisible);
        setFmttiVisible(false);
        setSmamVisible(false);
        setCrmDemoVisible(false);
        setFarmerVisible(false);
        setChcHistoryVisible(false);
        setSurveyorCreationVisible(false);
        if (!crmVisible) {
          await fetchCHCDetails();
          setTimeout(() => {
            const tableElement = document.getElementById('crm-details-table');
            if (tableElement) {
              tableElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }, 100);
        }
        break;
      case 'fmtti':
        setUserVisible(false);
        setCrmVisible(false);
        setFmttiVisible(!fmttiVisible);
        setSmamVisible(false);
        setCrmDemoVisible(false);
        setFarmerVisible(false);
        setChcHistoryVisible(false);
        setSurveyorCreationVisible(false);
        if (!fmttiVisible) {
          await fetchFMTTIDetails();
          setTimeout(() => {
            const tableElement = document.getElementById('fmtti-details-table');
            if (tableElement) {
              tableElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }, 100);
        }
        break;
      case 'smam':
        setUserVisible(false);
        setCrmVisible(false);
        setFmttiVisible(false);
        setSmamVisible(!smamVisible);
        setCrmDemoVisible(false);
        setFarmerVisible(false);
        setChcHistoryVisible(false);
        setSurveyorCreationVisible(false);
        if (!smamVisible) {
          await fetchSMAMCHCDetails();
          setTimeout(() => {
            const tableElement = document.getElementById('smam-details-table');
            if (tableElement) {
              tableElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }, 100);
        }
        break;
      case 'crmDemo':
        setUserVisible(false);
        setCrmVisible(false);
        setFmttiVisible(false);
        setSmamVisible(false);
        setCrmDemoVisible(!crmDemoVisible);
        setFarmerVisible(false);
        setChcHistoryVisible(false);
        setSurveyorCreationVisible(false);
        if (!crmDemoVisible) {
          await fetchCRMDemoData();
          setTimeout(() => {
            const tableElement = document.getElementById('crm-demo-table');
            if (tableElement) {
              tableElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }, 100);
        }
        break;
      case 'smamChc':
        setUserVisible(false);
        setCrmVisible(false);
        setFmttiVisible(false);
        setSmamVisible(false);
        setCrmDemoVisible(false);
        setFarmerVisible(false);
        setChcHistoryVisible(false);
        setSurveyorCreationVisible(false);
        setCrmChcVisible(false);
        setSmamChcVisible(!smamChcVisible);
        break;
      // CRM CHC handling moved to StateLoginDashboard component
      case 'rkvy':
        setUserVisible(false);
        setCrmVisible(false);
        setFmttiVisible(false);
        setSmamVisible(false);
        setCrmDemoVisible(false);
        setFarmerVisible(false);
        setChcHistoryVisible(false);
        setSurveyorCreationVisible(false);
        setSmamChcVisible(false);
        setCrmChcVisible(false);
        // For now, we'll show CHC history data for RKVY case
        if (!chcHistoryVisible) {
          await fetchCHCHistoryData();
          setTimeout(() => {
            const tableElement = document.getElementById('chc-history-table');
            if (tableElement) {
              tableElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }, 100);
        }
        break;
      case 'surveyorCreation':
        setUserVisible(false);
        setCrmVisible(false);
        setFmttiVisible(false);
        setSmamVisible(false);
        setCrmDemoVisible(false);
        setFarmerVisible(false);
        setChcHistoryVisible(false);
        setSurveyorCreationVisible(!surveyorCreationVisible);
        if (!surveyorCreationVisible) {
          await fetchSurveyorCreationDistrictDetails();
          setTimeout(() => {
            const tableElement = document.getElementById('surveyor-creation-table');
            if (tableElement) {
              tableElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }, 100);
        }
        break;
      case 'crmDemo':
        setUserVisible(false);
        setCrmVisible(false);
        setFmttiVisible(false);
        setSmamVisible(false);
        setCrmDemoVisible(!crmDemoVisible);
        setFarmerVisible(false);
        setChcHistoryVisible(false);
        setSurveyorCreationVisible(false);
        if (!crmDemoVisible) {
          await fetchCRMDemoData();
          setTimeout(() => {
            const tableElement = document.getElementById('crm-demo-table');
            if (tableElement) {
              tableElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }, 100);
        }
        break;
      case 'role7':
        setUserVisible(false);
        setCrmVisible(false);
        setFmttiVisible(false);
        setSmamVisible(false);
        setCrmDemoVisible(false);
        setFarmerVisible(false);
        setChcHistoryVisible(false);
        setSurveyorCreationVisible(false);
        setRole7Visible(!role7Visible);
        if (!role7Visible) {
          await fetchRole7Data();
          setTimeout(() => {
            const tableElement = document.getElementById('role7-details-table');
            if (tableElement) {
              tableElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }, 100);
        }
        break;
    }
    } catch (error) {
      console.error('Error in handleMoreInfoClick:', error);
      // You can add user-friendly error handling here if needed
    }
  };

  // Fetch detailed user data
  async function fetchUserDetails() {
    try {
      console.log('Fetching user details...');
      const userTypeCode = sessionStorage.getItem("userTypeCodeModel");
      const userRoleCode = sessionStorage.getItem("userRoleCodeModel");
      const userCode = sessionStorage.getItem("userCodeModel");
      
      let data;
      
      if (userRoleCode === "1") { // Central Admin - use GetDashboarReportCount with UserType flag
        console.log('Using GetDashboarReportCount API for central admin with UserType flag');
        const result = await axios({
          method: 'post',
          url: `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarReportCount`,
          headers: {
            'accept': '/',
            'Content-Type': 'application/json'
          },
          data: {
            "flag": "UserType",
            "userTypeCode": 0,
            "stateCode": 0
          }
        });
        data = result.data;
      } else if (userRoleCode === "2") { // State Admin - use GetStateDashboarCount with UserType flag
        console.log('=== STATE ADMIN USER DETAILS FLOW ===');
        console.log('Using GetStateDashboarCount API for state admin with UserType flag');
        const stateCode = sessionStorage.getItem("stateNameModel");
        console.log('StateCode from session:', stateCode);
        
        const apiPayload = {
          "flag": "UserType",
          "stateCode": parseInt(sessionStorage.getItem("stateNameModel")), //parseInt(stateCode),
          "userTypeCode": 0
        };
        
        console.log('State User Details API Payload:', apiPayload);
        
        const result = await axios({
          method: 'post',
          url: `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetStateDashboarCount`,
          headers: {
            'accept': '/',
            'Content-Type': 'application/json'
          },
          data: apiPayload
        });
        
        console.log('State User Details API Response:', result.data);
        data = result.data;
        console.log('=== END STATE ADMIN USER DETAILS FLOW ===');
      } else if (userRoleCode === "3") { // District Admin - use GetDistrictDashboarCount with UserType flag
        console.log('=== DISTRICT ADMIN USER DETAILS FLOW ===');
        console.log('Using GetDistrictDashboarCount API for district admin with UserType flag');
        
        const districtCode = getDistrictCode("districtNameModel");
        console.log('District Admin - Using district code for details:', districtCode);
        
        const apiPayload = {
          "flag": "UserType",
          "userTypeCode": 0,
          "stateCode": parseInt(sessionStorage.getItem("stateNameModel")),
          "districtCode": String(districtCode)
        };
        
        console.log('District User Details API Payload:', apiPayload);
        
        const result = await axios({
          method: 'post',
          url: `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDistrictDashboarCount`,
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          },
          data: apiPayload
        });
        
        console.log('District User Details API Response:', result.data);
        data = result.data;
        console.log('=== END DISTRICT ADMIN USER DETAILS FLOW ===');
      } else { // Other user types - use GetUsersDetailsCount
        console.log('Using GetUsersDetailsCount API for other user types');
        const result = await axios.get(
          `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetUsersDetailsCount`,
          {
            headers: {
              'accept': '*/*'
            }
          }
        );
        data = result.data;
      }
      
      console.log('User details API response:', data);
      
      if (data.success && data.dataContent) {
        setUserDetails(data.dataContent);
      } else {
        setUserDetails([]);
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
      setUserDetails([]);
    }
  }

  // Fetch detailed CRM data
  async function fetchCRMDetails() {
    try {
      const { data } = await axios.get(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetCHDetailsCount`,
        {
          headers: {
            'accept': '*/*'
          }
        }
      );
      
      if (data.success && data.dataContent) {
        setCrmDetails(data.dataContent);
      }
    } catch (error) {
      console.error('Error fetching CRM details:', error);
      setCrmDetails([]);
    }
  }

  // Fetch detailed FMTTI data
  async function fetchFMTTIDetails() {
    try {
      const { data } = await axios.get(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetFarmerDetailsCount`,
        {
          headers: {
            'accept': '*/*'
          }
        }
      );
      
      if (data.success && data.dataContent) {
        setFmttiDetails(data.dataContent);
      }
    } catch (error) {
      console.error('Error fetching FMTTI details:', error);
      setFmttiDetails([]);
    }
  }

  // Fetch detailed SMAM data (placeholder - you can modify as needed)
  async function fetchSMAMDetails() {
    try {
      // For now, we'll use the same user data but filter for Surveyor role
      const { data } = await axios.get(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetUsersDetailsCount`,
        {
          headers: {
            'accept': '*/*'
          }
        }
      );
      
      if (data.success && data.dataContent) {
        // Filter for surveyor users only
        const surveyorUsers = data.dataContent.filter(user => 
          user.userRoleNames && user.userRoleNames.toLowerCase().includes('surveyor')
        );
        setSmamDetails(surveyorUsers);
      }
    } catch (error) {
      console.error('Error fetching SMAM details:', error);
      setSmamDetails([]);
    }
  }

  // Fetch detailed CRM Demo data (placeholder - you can modify as needed)
  async function fetchCRMDemoDetails() {
    try {
      // This would be the same as CRM details for now
      const { data } = await axios.get(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetCHDetailsCount`,
        {
          headers: {
            'accept': '*/*'
          }
        }
      );
      
      if (data.success && data.dataContent) {
        setCrmDemoDetails(data.dataContent);
      }
    } catch (error) {
      console.error('Error fetching CRM Demo details:', error);
      setCrmDemoDetails([]);
    }
  }

  // Fetch detailed SMAM CHC data using GetDashboarSurveyorReportCountState API
  async function fetchSMAMChcDetails() {
    try {
      const stateCode = sessionStorage.getItem("stateNameModel");
      if (!stateCode) {
        console.error('State code not found in session storage');
        return;
      }

      console.log('Fetching SMAM CHC details...');
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCountState`,
        {
          "flag": "CHCCountS",
          "stateCode": parseInt(stateCode),
          "userTypeCode": 3
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('SMAM CHC API response:', data);
      
      if (data.success && data.dataContent) {
        // Transform the data to match the expected format
        const transformedData = data.dataContent.map(item => ({
          stateCode: item.stateCode,
          stateName: item.stateName,
          chcCount: item.total,
          totalFarmers: item.totalFarmers
        }));
        setSmamChcDetails(transformedData);
        console.log('SMAM CHC details set:', transformedData);
      } else {
        console.log('No SMAM CHC data received');
        setSmamChcDetails([]);
      }
    } catch (error) {
      console.error('Error fetching SMAM CHC details:', error);
      setSmamChcDetails([]);
    }
  }

  // Fetch detailed CRM CHC data using GetDashboarSurveyorReportCountState API
  async function fetchCRMChcDetails() {
    try {
      const userRoleCode = sessionStorage.getItem("userRoleCodeModel");
      const stateCode = sessionStorage.getItem("stateNameModel");
      
      console.log('Fetching CRM CHC details using GetDashboarSurveyorReportCountState...');
      console.log('UserRoleCode:', userRoleCode, 'StateCode:', stateCode);
      
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCountState`,
        {
          "flag": "CHCCountS",
          "userTypeCode": 2,
          "stateCode": parseInt(stateCode)
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('CRM CHC API response:', data);
      console.log('CRM CHC API response structure:', {
        success: data.success,
        hasDataContent: !!data.dataContent,
        dataContentLength: data.dataContent ? data.dataContent.length : 0,
        recordCount: data.recordCount,
        message: data.message
      });
      
      if (data.success && data.dataContent && data.dataContent.length > 0) {
        setCrmChcDetails(data.dataContent);
        console.log('CRM CHC details set successfully:', data.dataContent);
      } else if (data.success && data.recordCount) {
        // Handle case where recordCount is at root level
        console.log('Using recordCount for CRM CHC details:', data.recordCount);
        setCrmChcDetails([{ count: data.recordCount }]);
      } else {
        console.log('No CRM CHC data received - API response:', data);
        setCrmChcDetails([]);
      }
    } catch (error) {
      console.error('Error fetching CRM CHC details:', error);
      setCrmChcDetails([]);
    }
  }

  // Fetch detailed CHC data using GetDashboarSurveyorReportCount API with state-wise breakdown
  async function fetchCHCDetails() {
    try {
      const userRoleCode = sessionStorage.getItem("userRoleCodeModel");
      const stateCode = sessionStorage.getItem("stateNameModel");
      
      console.log('=== DEBUGGING CHC DETAILS API ===');
      console.log('Fetching CHC details with state-wise breakdown...');
      console.log('fetchCHCDetails called for userRoleCode:', userRoleCode);
      console.log('fetchCHCDetails stateCode from session:', stateCode);
      console.log('All session storage keys:', Object.keys(sessionStorage));
      console.log('userRoleCodeModel value:', sessionStorage.getItem("userRoleCodeModel"));
      console.log('userTypeCodeModel value:', sessionStorage.getItem("userTypeCodeModel"));
      console.log('stateNameModel value:', sessionStorage.getItem("stateNameModel"));
      console.log('==================================');
      
      // Determine userTypeCode and stateCode based on user role
      let userTypeCode;
      let apiStateCode;
      
      if (userRoleCode === "1") { // Central Admin
        userTypeCode = 1;
        apiStateCode = 0; // Central admin sees all states
      } else if (userRoleCode === "2") { // State Admin
        userTypeCode = 2;
        apiStateCode = parseInt(stateCode);
      } else if (userRoleCode === "3") { // District Admin
        userTypeCode = 3;
        apiStateCode = parseInt(stateCode);
      } else {
        // Default fallback
        userTypeCode = 2;
        apiStateCode = 0;
      }
      
      const apiPayload = {
        "flag": "CHCCountS",
        "userTypeCode": userTypeCode,
        "stateCode": apiStateCode
      };
      
      console.log('CHC Details API Payload:', apiPayload);
      console.log('Final userTypeCode being sent:', userTypeCode);
      console.log('Final stateCode being sent:', apiStateCode);
      
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCount`,
        apiPayload,
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('CHC Details API response:', data);
      
      if (data.success && data.dataContent) {
        // Transform the data to include state-wise breakdown
        const transformedData = data.dataContent.map(item => ({
          stateCode: item.stateCode,
          stateName: item.stateName,
          total: parseInt(item.total) || 0,
          flag: item.flag,
          createdBy: item.createdBy,
          userTypeCode: item.userTypeCode,
          totalFarmers: item.totalFarmers,
          districtCode: item.districtCode,
          districtNames: item.districtNames
        }));
        
        setCrmChcDetails(transformedData);
        console.log('CHC details set with state-wise breakdown:', transformedData);
      } else {
        console.log('No CHC data received');
        setCrmChcDetails([]);
      }
    } catch (error) {
      console.error('Error fetching CHC details:', error);
      setCrmChcDetails([]);
    }
  }

  // Fetch CHC district details using GetDashboarSurveyorReportCount API with district-wise breakdown
  async function fetchCHCDistrictDetails(stateCode) {
    try {
      console.log('Fetching CHC district details for state code:', stateCode);
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCount`,
        {
          "flag": "CHCCountD",
          "userTypeCode": 2, // Changed from 3 to 2 for CRM CHC
          "stateCode": stateCode
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('CHC District Details API response:', data);
      
      if (data.success && data.dataContent) {
        // Transform the data to include district-wise breakdown
        const transformedData = data.dataContent.map(item => ({
          stateCode: item.stateCode,
          stateName: item.stateName,
          districtCode: item.districtCode,
          districtNames: item.districtNames,
          total: parseInt(item.total) || 0,
          flag: item.flag,
          createdBy: item.createdBy,
          userTypeCode: item.userTypeCode,
          totalFarmers: item.totalFarmers
        }));
        
        setExpandedChcDistrictData(transformedData);
        console.log('CHC district details set:', transformedData);
      } else {
        console.log('No CHC district data received');
        setExpandedChcDistrictData([]);
      }
    } catch (error) {
      console.error('Error fetching CHC district details:', error);
      setExpandedChcDistrictData([]);
    }
  }

  // Fetch detailed SMAM CHC data using GetDashboarSurveyorReportCount API with state-wise breakdown
  async function fetchSMAMCHCDetails() {
    try {
      console.log('Fetching SMAM CHC details with state-wise breakdown...');
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCountState`,
        {
          "flag": "CHCCountS",
          "userTypeCode": 3,
          "stateCode": parseInt(sessionStorage.getItem("stateNameModel"))
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('SMAM CHC Details API response:', data);
      
      if (data.success && data.dataContent) {
        // Transform the data to include state-wise breakdown
        const transformedData = data.dataContent.map(item => ({
          stateCode: item.stateCode,
          stateName: item.stateName,
          total: parseInt(item.total) || 0,
          flag: item.flag,
          createdBy: item.createdBy,
          userTypeCode: item.userTypeCode,
          totalFarmers: item.totalFarmers,
          districtCode: item.districtCode,
          districtNames: item.districtNames
        }));
        
        setSmamChcDetails(transformedData);
        console.log('SMAM CHC details set with state-wise breakdown:', transformedData);
      } else {
        console.log('No SMAM CHC data received');
        setSmamChcDetails([]);
      }
    } catch (error) {
      console.error('Error fetching SMAM CHC details:', error);
      setSmamChcDetails([]);
    }
  }

  // Fetch SMAM CHC district details using GetDashboarSurveyorReportCount API with district-wise breakdown
  async function fetchSMAMCHCDistrictDetails(stateCode) {
    try {
      console.log('Fetching SMAM CHC district details for state code:', stateCode);
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCount`,
        {
          "flag": "CHCCountD",
          "userTypeCode": 3,
          "stateCode": stateCode //parseInt(sessionStorage.getItem("stateNameModel"))
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('SMAM CHC District Details API response:', data);
      
      if (data.success && data.dataContent) {
        // Transform the data to include district-wise breakdown
        const transformedData = data.dataContent.map(item => ({
          stateCode: item.stateCode,
          stateName: item.stateName,
          districtCode: item.districtCode,
          districtNames: item.districtNames,
          total: parseInt(item.total) || 0,
          flag: item.flag,
          createdBy: item.createdBy,
          userTypeCode: item.userTypeCode,
          totalFarmers: item.totalFarmers
        }));
        
        setExpandedSmamChcDistrictData(transformedData);
        console.log('SMAM CHC district details set:', transformedData);
      } else {
        console.log('No SMAM CHC district data received');
        setExpandedSmamChcDistrictData([]);
      }
    } catch (error) {
      console.error('Error fetching SMAM CHC district details:', error);
      setExpandedSmamChcDistrictData([]);
    }
  }

  // Fetch detailed FMTTI data using GetDashboarSurveyorReportCount API with state-wise breakdown
  async function fetchFMTTIDetails() {
    try {
      console.log('Fetching FMTTI details with state-wise breakdown...');
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCount`,
        {
          "flag": "FarmerS",
          "userTypeCode": 1,
          "stateCode": 0
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('FMTTI Details API response:', data);
      
      if (data.success && data.dataContent) {
        // Transform the data to include state-wise breakdown
        const transformedData = data.dataContent.map(item => ({
          stateCode: item.stateCode,
          stateName: item.stateName,
          total: parseInt(item.totalFarmers) || 0,
          flag: item.flag,
          createdBy: item.createdBy,
          userTypeCode: item.userTypeCode,
          totalFarmers: item.totalFarmers,
          districtCode: item.districtCode,
          districtNames: item.districtNames
        }));
        
        setFmttiStateDetails(transformedData);
        console.log('FMTTI details set with state-wise breakdown:', transformedData);
      } else {
        console.log('No FMTTI data received');
        setFmttiStateDetails([]);
      }
    } catch (error) {
      console.error('Error fetching FMTTI details:', error);
      setFmttiStateDetails([]);
    }
  }

  // Fetch FMTTI district details using GetDashboarSurveyorReportCount API with district-wise breakdown
  async function fetchFMTTIDistrictDetails(stateCode) {
    try {
      console.log('Fetching FMTTI district details for state code:', stateCode);
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCount`,
        {
          "flag": "FarmerD",
          "userTypeCode": 1,
          "stateCode": stateCode
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('FMTTI District Details API response:', data);
      
      if (data.success && data.dataContent) {
        // Transform the data to include district-wise breakdown
        const transformedData = data.dataContent.map(item => ({
          stateCode: item.stateCode,
          stateName: item.stateName,
          districtCode: item.districtCode,
          districtNames: item.districtNames,
          total: parseInt(item.totalFarmers) || 0,
          flag: item.flag,
          createdBy: item.createdBy,
          userTypeCode: item.userTypeCode,
          totalFarmers: item.totalFarmers
        }));
        
        setExpandedFmttiDistrictData(transformedData);
        console.log('FMTTI district details set:', transformedData);
      } else {
        console.log('No FMTTI district data received');
        setExpandedFmttiDistrictData([]);
      }
    } catch (error) {
      console.error('Error fetching FMTTI district details:', error);
      setExpandedFmttiDistrictData([]);
    }
  }

  // Fetch detailed CRM Demo data using GetDashboarSurveyorReportCount API with state-wise breakdown
  async function fetchCRMDemoDetails() {
    try {
      const userRoleCode = sessionStorage.getItem("userRoleCodeModel");
      const stateCode = sessionStorage.getItem("stateNameModel");
      
      console.log('Fetching CRM Demo details with state-wise breakdown...');
      console.log('fetchCRMDemoDetails called for userRoleCode:', userRoleCode);
      
      // Determine userTypeCode and stateCode based on user role
      let userTypeCode;
      let apiStateCode;
      
      if (userRoleCode === "1") { // Central Admin
        userTypeCode = 1;
        apiStateCode = 0; // Central admin sees all states
      } else if (userRoleCode === "2") { // State Admin
        userTypeCode = 2;
        apiStateCode = parseInt(stateCode);
      } else if (userRoleCode === "3") { // District Admin
        userTypeCode = 3;
        apiStateCode = parseInt(stateCode);
      } else {
        // Default fallback
        userTypeCode = 2;
        apiStateCode = 0;
      }
      
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCount`,
        {
          "flag": "FarmerS",
          "userTypeCode": userTypeCode,
          "stateCode": apiStateCode
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('CRM Demo Details API response:', data);
      
      if (data.success && data.dataContent) {
        // Transform the data to include state-wise breakdown
        const transformedData = data.dataContent.map(item => ({
          stateCode: item.stateCode,
          stateName: item.stateName,
          total: parseInt(item.totalFarmers) || 0,
          flag: item.flag,
          createdBy: item.createdBy,
          userTypeCode: item.userTypeCode,
          totalFarmers: item.totalFarmers,
          districtCode: item.districtCode,
          districtNames: item.districtNames
        }));
        
        setCrmDemoStateDetails(transformedData);
        console.log('CRM Demo details set with state-wise breakdown:', transformedData);
      } else {
        console.log('No CRM Demo data received');
        setCrmDemoStateDetails([]);
      }
    } catch (error) {
      console.error('Error fetching CRM Demo details:', error);
      setCrmDemoStateDetails([]);
    }
  }

  // Fetch CRM Demo district details using GetDashboarSurveyorReportCount API with district-wise breakdown
  async function fetchCRMDemoDistrictDetails(stateCode) {
    try {
      console.log('Fetching CRM Demo district details for state code:', stateCode);
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarSurveyorReportCount`,
        {
          "flag": "FarmerD",
          "userTypeCode": 2,
          "stateCode": stateCode
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('CRM Demo District Details API response:', data);
      
      if (data.success && data.dataContent) {
        // Transform the data to include district-wise breakdown
        const transformedData = data.dataContent.map(item => ({
          stateCode: item.stateCode,
          stateName: item.stateName,
          districtCode: item.districtCode,
          districtNames: item.districtNames,
          total: parseInt(item.totalFarmers) || 0,
          flag: item.flag,
          createdBy: item.createdBy,
          userTypeCode: item.userTypeCode,
          totalFarmers: item.totalFarmers
        }));
        
        setExpandedCrmDemoDistrictData(transformedData);
        console.log('CRM Demo district details set:', transformedData);
      } else {
        console.log('No CRM Demo district data received');
        setExpandedCrmDemoDistrictData([]);
      }
    } catch (error) {
      console.error('Error fetching CRM Demo district details:', error);
      setExpandedCrmDemoDistrictData([]);
    }
  }

  // Export functions
  const exportToCSV = (data, filename, headers) => {
    if (!data || data.length === 0) {
      alert("No data available to export.");
      return;
    }

    const csvRows = [headers.join(",")];

    data.forEach((item, index) => {
      let row = [index + 1];
      
      // Handle different data structures based on headers
      if (headers.includes("District Name") && headers.includes("Count")) {
        // District summary data
        row.push(`"${item.districtName || 'N/A'}"`);
        row.push(`"${item.totalUsers || 0}"`);
      } else if (headers.includes("User Name") && headers.includes("User Code")) {
        // Surveyor details data
        row.push(`"${item.userName || 'N/A'}"`);
        row.push(`"${item.userCode || 'N/A'}"`);
        row.push(`"${item.userRoleName || 'N/A'}"`);
        row.push(`"${item.districtName || 'N/A'}"`);
      } else if (headers.includes("Farmer Name") && headers.includes("Farmer Code")) {
        // Farmer details data
        row.push(`"${item.farmerName || 'N/A'}"`);
        row.push(`"${item.farmerCode || 'N/A'}"`);
        row.push(`"${item.mobileNo || 'N/A'}"`);
        row.push(`"${item.stateName || 'N/A'}"`);
        row.push(`"${item.districtName || 'N/A'}"`);
        row.push(`"${item.villageName || 'N/A'}"`);
        row.push(`"${item.cropName || 'N/A'}"`);
        row.push(`"${item.usedMachineName || 'N/A'}"`);
        row.push(`"${item.totalAreaInHA || 'N/A'}"`);
      } else if (headers.includes("State Name")) {
        row.push(`"${item.stateName || 'N/A'}"`);
        row.push(`"${item.totalUsers || item.total || item.totalFarmers || item.recordCount || 0}"`);
      } else if (headers.includes("Role Name")) {
        row.push(`"${item.userRoleName || item.roleName || 'N/A'}"`);
        row.push(`"${item.totalUsers || 0}"`);
      } else {
        // Default fallback
        row.push(`"${item.stateName || item.districtName || 'N/A'}"`);
        row.push(`"${item.totalUsers || item.total || item.totalFarmers || item.recordCount || 0}"`);
      }
      
      csvRows.push(row.join(","));
    });

    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${filename}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportUserData = () => {
    const headers = ["S.No", "State Name", "No of Users"];
    exportToCSV(userDetails, "MT_Active_Users_Report", headers);
  };

  const exportCRMData = () => {
    const headers = ["S.No", "State Name", "No of Users"];
    exportToCSV(crmChcDetails, "MT_CRM_CHC_Report", headers);
  };


  const exportFMTTIData = () => {
    const headers = ["S.No", "State Name", "No of Users"];
    exportToCSV(fmttiStateDetails, "MT_FMTTI_Demonstration_Report", headers);
  };

  const exportSMAMData = () => {
    const headers = ["S.No", "State Name", "No of Users"];
    exportToCSV(smamChcDetails, "MT_SMAM_CHC_Report", headers);
  };

  const exportCRMDemoData = () => {
    const headers = ["S.No", "State Name", "No of Users"];
    exportToCSV(crmDemoStateDetails, "MT_CRM_Machine_Demo_Report", headers);
  };

  const exportFarmerData = () => {
    const headers = ["S.No", "State Name", "No of Users"];
    exportToCSV(farmerDetails, "MT_Farmer_Registration_Report", headers);
  };

  const exportCHCHistoryData = () => {
    const headers = ["S.No", "State Name", "No of Users"];
    exportToCSV(chcHistoryDetails, "MT_CHC_History_Report", headers);
  };

  const exportSurveyorCreationData = () => {
    const headers = ["S.No", "District Name", "Count"];
    exportToCSV(surveyorCreationDetails, "MT_Surveyor_Creation_Report", headers);
  };

  const exportSurveyorDetailsData = () => {
    const headers = ["S.No", "User Name", "User Code", "Role Name", "District Name"];
    exportToCSV(expandedSurveyorData, "MT_Surveyor_Details_Report", headers);
  };

  const exportCRMDemoFarmerData = () => {
    const headers = ["S.No", "Farmer Name", "Farmer Code", "Mobile No", "State", "District", "Village", "Crop Name", "Machine Used", "Area (HA)"];
    exportToCSV(crmDemoDetails, "MT_CRM_Demo_Farmer_Report", headers);
  };

  // Export functions for drill-down tables
  const exportExpandedRowData = () => {
    const headers = ["S.No", "State Name", "User Count"];
    exportToCSV(expandedRowData, "MT_Expanded_User_Details", headers);
  };

  const exportExpandedSMAMData = () => {
    const headers = ["S.No", "State Name", "User Count"];
    exportToCSV(expandedSMAMData, "MT_SMAM_State_Details", headers);
  };

  const exportExpandedCRMData = () => {
    const headers = ["S.No", "Role Name", "User Count"];
    exportToCSV(expandedCRMData, "MT_CRM_Details", headers);
  };

  const exportExpandedFMTTIData = () => {
    const headers = ["S.No", "Role Name", "User Count"];
    exportToCSV(expandedFMTTIData, "MT_FMTTI_Role_Details", headers);
  };

  const exportExpandedStateData = () => {
    const headers = ["S.No", "State Name", "User Count"];
    exportToCSV(expandedStateData, "MT_State_Details", headers);
  };

  const exportExpandedDistrictData = () => {
    const headers = ["S.No", "District Name", "User Count"];
    exportToCSV(expandedDistrictData, "MT_District_Details", headers);
  };

  const exportExpandedChcDistrictData = () => {
    const headers = ["S.No", "District Name", "User Count"];
    exportToCSV(expandedChcDistrictData, "MT_CHC_District_Details", headers);
  };

  const exportExpandedSmamChcDistrictData = () => {
    const headers = ["S.No", "District Name", "User Count"];
    exportToCSV(expandedSmamChcDistrictData, "MT_SMAM_CHC_District_Details", headers);
  };

  const exportExpandedFmttiDistrictData = () => {
    const headers = ["S.No", "District Name", "User Count"];
    exportToCSV(expandedFmttiDistrictData, "MT_FMTTI_District_Details", headers);
  };

  const exportExpandedCrmDemoDistrictData = () => {
    const headers = ["S.No", "District Name", "User Count"];
    exportToCSV(expandedCrmDemoDistrictData, "MT_CRM_Demo_District_Details", headers);
  };

  const exportExpandedStateUserTypeData = () => {
    const headers = ["S.No", "District Name", "User Count"];
    exportToCSV(expandedStateUserTypeData, "MT_State_UserType_District_Details", headers);
  };

  const exportExpandedStateDistrictData = () => {
    const headers = ["S.No", "District Name", "User Count"];
    exportToCSV(expandedStateDistrictData, "MT_State_District_Details", headers);
  };

  const exportExpandedSMAMDistrictData = () => {
    const headers = ["S.No", "District Name", "User Count"];
    exportToCSV(expandedSMAMDistrictData, "MT_SMAM_District_Details", headers);
  };

const handleRowToggle = async (index, survey) => {
  //alert();
  if (expandedRowIndex === index) {
    setExpandedRowIndex(null); // collapse
    setExpandedRowData([]); // clear data when collapsing
  } else {
    setExpandedRowIndex(index); // expand
    // Clear all other data arrays to prevent conflicts
    setExpandedRowData([]);
    // Don't clear expandedSMAMData if we're dealing with SMAM
    if (!(survey?.userTypeName === "SMAM" || survey?.roleName === "SMAM")) {
      setExpandedSMAMData([]);
    }
    setExpandedCRMData([]);
    setExpandedFMTTIData([]);
    const userTypeCode = sessionStorage.getItem("userTypeCodeModel");
    const userRoleCode = sessionStorage.getItem("userRoleCodeModel");
    
    try {
      let data;
      
      if (userRoleCode === "1") { // Central Admin - handle different user types
        console.log('Central admin drill-down for user type:', survey?.userTypeName || survey?.roleName);
        
        // Check which user type was clicked
        if (survey?.userTypeName === "CRM" || survey?.roleName === "CRM") {
          // For CRM - fetch state-wise data using standardized API
          console.log('Fetching CRM state-wise data using standardized API');
          const result = await axios({
            method: 'post',
            url: `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarReportCount`,
            headers: {
              'accept': '/',
              'Content-Type': 'application/json'
            },
            data: {
              "flag": "CRMUserTyp",
              "userTypeCode": 2,
              "stateCode": 0
            }
          });
          data = result.data;
          console.log('CRM State API Response:', data);
        } else if (survey?.userTypeName === "SMAM" || survey?.userTypeCode === "3" || survey?.roleName === "SMAM") {
          // For SMAM - fetch state-wise data using standardized API
          console.log('Fetching SMAM state-wise data using standardized API');
          const result = await axios({
            method: 'post',
            url: `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarReportCount`,
            headers: {
              'accept': '/',
              'Content-Type': 'application/json'
            },
            data: {
              "flag": "State",
              "userTypeCode": 3,
              "stateCode": 0
            }
          });
          data = result.data;
          console.log('SMAM State API Response:', data);
          // Set the state data directly for SMAM with proper transformation
          if (data.success && data.dataContent && Array.isArray(data.dataContent)) {
            const transformedData = data.dataContent.map(item => ({
              stateName: item.stateName || 'N/A',
              totalUsers: parseInt(item.totalUsers) || 0,
              stateCode: item.stateCode || 0,
              userTypeCode: 3
            }));
            setExpandedSMAMData(transformedData);
            console.log('SMAM data set in handleRowToggle:', transformedData);
          }
        } else if (survey?.userTypeName === "FMTTI" || survey?.roleName === "FMTTI") {
          // For FMTTI - fetch user roles using standardized API
          console.log('Fetching FMTTI user roles using standardized API');
          const result = await axios({
            method: 'post',
            url: `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarReportCount`,
            headers: {
              'accept': '/',
              'Content-Type': 'application/json'
            },
            data: {
              "flag": "FMTTIUserRole",
              "userTypeCode": 0,
              "stateCode": 0
            }
          });
          data = result.data;
          console.log('FMTTI User Roles API Response:', data);
        } else {
          // For other user types - show static data
          data = {
            success: true,
            dataContent: [
              { userTypeName: "No Data", userTypeCode: 0, recordCount: 0 }
            ]
          };
        }
      } else if (userRoleCode === "2") { // State Admin - handle user type drill-down
        console.log('=== STATE ADMIN USER TYPE DRILL-DOWN ===');
        console.log('Fetching drill-down data for user type:', survey?.userTypeName);
        
        // For state admin, we can drill down by districts within the state
        const stateCode = sessionStorage.getItem("stateNameModel");
        console.log('StateCode from session:', stateCode);
        
        if (survey?.userTypeName) {
          let flag = "";
          
          // Determine the flag based on user type
          if (survey.userTypeName === "FMTTI") {
            flag = "FMTTIUserRole";
          } else if (survey.userTypeName === "CRM") {
            flag = "CRMUserTyp";
          } else if (survey.userTypeName === "SMAM") {
            flag = "State";
          } else {
            data = {
              success: false,
              dataContent: []
            };
            return;
          }
          
          // Make API call to get user roles for this user type
          const result = await axios({
            method: 'post',
            url: `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetStateDashboarCount`,
            headers: {
              'accept': '*/*',
              'Content-Type': 'application/json'
            },
            data: {
              "flag": flag,
              "stateCode": parseInt(stateCode),
              "userTypeCode": survey.userTypeName === "SMAM" ? 3 : 0
            }
          });
          
          console.log('State User Type District API Response:', result.data);
          data = result.data;
        } else {
          data = {
            success: false,
            dataContent: []
          };
        }
        console.log('=== END STATE ADMIN USER TYPE DRILL-DOWN ===');
      } else if (userRoleCode === "3") { // District Admin - use GetDistrictDashboarCount API
        console.log('=== DISTRICT ADMIN USER TYPE DRILL-DOWN ===');
        console.log('Fetching drill-down data for user type:', survey?.userTypeName);
        
        const stateCode = sessionStorage.getItem("stateNameModel");
        const districtCode = getDistrictCode("districtNameModel");
        console.log('StateCode from session:', stateCode);
        console.log('DistrictCode from session:', districtCode);
        
        if (survey?.userTypeName) {
          let flag = "";
          
          // Determine the flag based on user type
          if (survey.userTypeName === "FMTTI") {
            flag = "FMTTIUserRole";
          } else if (survey.userTypeName === "CRM") {
            flag = "CRMUserTyp";
          } else if (survey.userTypeName === "SMAM") {
            flag = "State";
          } else {
            data = {
              success: false,
              dataContent: []
            };
            return;
          }
          
          // Make API call to get user roles for this user type using district-specific API
          const result = await axios({
            method: 'post',
            url: `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDistrictDashboarCount`,
            headers: {
              'accept': '*/*',
              'Content-Type': 'application/json'
            },
            data: {
              "flag": flag,
              "stateCode": parseInt(stateCode),
              "districtCode": String(districtCode),
              "userTypeCode": 3 //survey.userTypeName === "SMAM" ? 3 : 0
            }
          });
          
          console.log('District User Type District API Response:', result.data);
          data = result.data;
        } else {
          data = {
            success: false,
            dataContent: []
          };
        }
        console.log('=== END DISTRICT ADMIN USER TYPE DRILL-DOWN ===');
      } else {
        // For other user types, use the original logic
        const schemeCode = sessionStorage.getItem("schemeCodeModel");
        const stateCode = sessionStorage.getItem("stateCodeModel");
        const userCode = sessionStorage.getItem("userCodeModel");
        
        let parm = {
          schemeCode: schemeCode,
          userLevel: parseInt(userTypeCode) + 1,
          str_FinYear: selectedFinYear === 'All' ? '' : selectedFinYear
        };

        // Handle parameters based on user type
        if (userTypeCode === "2") { // District Login
          // Handle multiple districts for district login using helper function
          const districtCode = getDistrictCode("districtCodeModel", survey?.districtCode || 0);
          
          parm = {
            ...parm,
            stateCode:  stateCode === "0" ? 0 : parseInt(stateCode),
            districtCode: String(districtCode),
            subDistrictCode: 0
          };
        } else if (userTypeCode === "3") { // Sub-District Login
          // Handle multiple districts for sub-district login using helper function
          const districtCode = getDistrictCode("districtCodeModel", 0);
          
          parm = {
            ...parm,
            stateCode:  stateCode === "0" ? 0 : parseInt(stateCode),
            districtCode: String(districtCode),
            subDistrictCode: survey?.subDistrictCode || 0
          };
        }

        // Convert any "null" strings to 0
        Object.keys(parm).forEach(key => {
          if (parm[key] === "null" || parm[key] === null) {
            parm[key] = 0;
          }
        });

        console.log("Fetching expanded data with params:", parm);
       
        const result = await axios.post(
            `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/SurveyCountGroupWise/UsersCountGroupWise`,
            parm
        );
        data = result.data;
      }
      
      console.log("Expanded row data received:", data);
      
      if (data.success && data.dataContent && Array.isArray(data.dataContent)) {
        // Transform CRM data to match expected format
        if (survey?.userTypeName === "CRM" || survey?.roleName === "CRM") {
          const transformedData = data.dataContent.map(item => ({
            stateName: item.stateName || item.category || 'N/A',
            userTypeName: item.stateName || item.category || 'N/A',
            userTypeCode: item.userTypeCode || 2,
            stateCode: item.stateCode || 0,
            recordCount: parseInt(item.totalUsers) || 0,
            totalUsers: parseInt(item.totalUsers) || 0
          }));
          setExpandedRowData(transformedData);
        } 
        // Transform FMTTI data to match expected format
        else if (survey?.userTypeName === "FMTTI" || survey?.roleName === "FMTTI") {
          const transformedData = data.dataContent.map(item => ({
            userTypeName: item.userRoleName,
            userTypeCode: parseInt(item.userRoleCode) || 0,
            recordCount: parseInt(item.totalUsers) || 0,
            totalUsers: parseInt(item.totalUsers) || 0
          }));
          setExpandedRowData(transformedData);
        } 
        // Transform State Admin drill-down data (user roles breakdown)
        else if (userRoleCode === "2") {
          if (survey?.userTypeName === "SMAM") {
            // For SMAM, set state data directly
            console.log('Setting SMAM data to expandedSMAMData (State Admin):', data.dataContent);
            setExpandedSMAMData(data.dataContent);
            setExpandedRowData([]); // Ensure expandedRowData is empty for SMAM
          } else {
            const transformedData = data.dataContent.map(item => ({
              userRoleName: item.userRoleName || 'N/A',
              userRoleCode: item.userRoleCode || 0,
              totalUsers: parseInt(item.totalUsers) || 0,
              userTypeName: survey?.userTypeName || 'N/A'
            }));
            setExpandedRowData(transformedData);
          }
        } 
        // Transform District Admin drill-down data (user roles breakdown)
        else if (userRoleCode === "3") {
          if (survey?.userTypeName === "SMAM") {
            // For SMAM, set state data directly
            console.log('Setting SMAM data to expandedSMAMData:', data.dataContent);
            console.log('Data structure check - first item:', data.dataContent[0]);
            setExpandedSMAMData(data.dataContent);
            setExpandedRowData([]); // Ensure expandedRowData is empty for SMAM
            console.log('expandedSMAMData should now be set to:', data.dataContent);
          } else {
            const transformedData = data.dataContent.map(item => ({
              userRoleName: item.userRoleName || 'N/A',
              userRoleCode: item.userRoleCode || 0,
              totalUsers: parseInt(item.totalUsers) || 0,
              userTypeName: survey?.userTypeName || 'N/A'
            }));
            setExpandedRowData(transformedData);
          }
        } else if (!(survey?.userTypeName === "SMAM" || survey?.roleName === "SMAM")) {
          setExpandedRowData(data.dataContent);
        }
      } else {
        console.error("Invalid expanded data format received:", data);
        setExpandedRowData([]);
      }
      } catch (error) {
      console.error("Error fetching expanded details:", error);
      setExpandedRowData([]);
    }
  }
};

// Function to handle second level drill-down (State-wise details)
const handleStateToggle = async (index, stateItem) => {
  if (expandedStateIndex === index) {
    setExpandedStateIndex(null); // collapse
    setExpandedStateData([]); // clear data when collapsing
  } else {
    setExpandedStateIndex(index); // expand
    const userTypeCode = sessionStorage.getItem("userTypeCodeModel");
    
    try {
      if (userTypeCode === "1") { // Central Admin - get state-wise details using standardized API
        console.log('Fetching state-wise details for:', stateItem);
        const result = await axios({
          method: 'post',
          url: `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarReportCount`,
          headers: {
            'accept': '/',
            'Content-Type': 'application/json'
          },
          data: {
            "flag": "State",
            "userTypeCode": 3, // Use 3 for SMAM
            "stateCode": 0
          }
        });
        
        console.log("State-wise details received:", result.data);
        
        if (result.data.success && result.data.dataContent && Array.isArray(result.data.dataContent)) {
          setExpandedStateData(result.data.dataContent);
        } else {
          console.error("Invalid state-wise data format received:", result.data);
          setExpandedStateData([]);
        }
      }
    } catch (error) {
      console.error("Error fetching state-wise details:", error);
      setExpandedStateData([]);
    }
  }
};

// Function to handle third level drill-down (District-wise details)
const handleDistrictToggle = async (index, stateItem) => {
  if (expandedDistrictIndex === index) {
    setExpandedDistrictIndex(null); // collapse
    setExpandedDistrictData([]); // clear data when collapsing
  } else {
    setExpandedDistrictIndex(index); // expand
    const userTypeCode = sessionStorage.getItem("userTypeCodeModel");
    
    try {
      if (userTypeCode === "1") { // Central Admin - get district-wise details using standardized API
        console.log('Fetching district-wise details for state:', stateItem);
        console.log('State code being used:', stateItem.stateCode);
        
        const result = await axios({
          method: 'post',
          url: `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarReportCount`,
          headers: {
            'accept': '/',
            'Content-Type': 'application/json'
          },
          data: {
            "flag": "District",
            "userTypeCode": sessionStorage.getItem("userTypeCodeModel"),
            "stateCode": sessionStorage.getItem("stateNameModel")
          }
        });
        
        console.log("District-wise details received:", result.data);
        
        if (result.data.success && result.data.dataContent && Array.isArray(result.data.dataContent)) {
          setExpandedDistrictData(result.data.dataContent);
        } else {
          console.error("Invalid district-wise data format received:", result.data);
          setExpandedDistrictData([]);
        }
      }
    } catch (error) {
      console.error("Error fetching district-wise details:", error);
      setExpandedDistrictData([]);
    }
  }
};

// Function to handle CHC district drill-down
const handleCHCDistrictToggle = async (index, stateItem) => {
  console.log('handleCHCDistrictToggle called with index:', index, 'stateItem:', stateItem);
  console.log('Current expandedChcStateIndex:', expandedChcStateIndex);
  
  if (expandedChcStateIndex === index) {
    console.log('Collapsing CHC district details');
    setExpandedChcStateIndex(null); // collapse
    setExpandedChcDistrictData([]); // clear data when collapsing
  } else {
    console.log('Expanding CHC district details');
    setExpandedChcStateIndex(index); // expand
    
    try {
      console.log('Fetching CHC district-wise details for state:', stateItem);
      console.log('State code being used:', stateItem.stateCode);
      
      await fetchCHCDistrictDetails(stateItem.stateCode);
    } catch (error) {
      console.error("Error fetching CHC district-wise details:", error);
      setExpandedChcDistrictData([]);
    }
  }
};

// Function to handle SMAM CHC district drill-down
const handleSMAMCHCDistrictToggle = async (index, stateItem) => {
  if (expandedSmamChcStateIndex === index) {
    setExpandedSmamChcStateIndex(null); // collapse
    setExpandedSmamChcDistrictData([]); // clear data when collapsing
  } else {
    setExpandedSmamChcStateIndex(index); // expand
    
    try {
      console.log('Fetching SMAM CHC district-wise details for state:', stateItem);
      console.log('State code being used:', stateItem.stateCode);
      
      await fetchSMAMCHCDistrictDetails(stateItem.stateCode);
    } catch (error) {
      console.error("Error fetching SMAM CHC district-wise details:", error);
      setExpandedSmamChcDistrictData([]);
    }
  }
};

// Function to handle FMTTI district drill-down
const handleFMTTIDistrictToggle = async (index, stateItem) => {
  if (expandedFmttiStateIndex === index) {
    setExpandedFmttiStateIndex(null); // collapse
    setExpandedFmttiDistrictData([]); // clear data when collapsing
  } else {
    setExpandedFmttiStateIndex(index); // expand
    
    try {
      console.log('Fetching FMTTI district-wise details for state:', stateItem);
      console.log('State code being used:', stateItem.stateCode);
      
      await fetchFMTTIDistrictDetails(stateItem.stateCode);
    } catch (error) {
      console.error("Error fetching FMTTI district-wise details:", error);
      setExpandedFmttiDistrictData([]);
    }
  }
};

// Function to handle CRM Demo district drill-down
const handleCRMDemoDistrictToggle = async (index, stateItem) => {
  if (expandedCrmDemoStateIndex === index) {
    setExpandedCrmDemoStateIndex(null); // collapse
    setExpandedCrmDemoDistrictData([]); // clear data when collapsing
  } else {
    setExpandedCrmDemoStateIndex(index); // expand
    
    try {
      console.log('Fetching CRM Demo district-wise details for state:', stateItem);
      console.log('State code being used:', stateItem.stateCode);
      
      await fetchCRMDemoDistrictDetails(stateItem.stateCode);
    } catch (error) {
      console.error("Error fetching CRM Demo district-wise details:", error);
      setExpandedCrmDemoDistrictData([]);
    }
  }
};

// Function to handle CRM drill-down
const handleCRMToggle = async (index, item) => {
  if (expandedCRMIndex === index) {
    setExpandedCRMIndex(null); // collapse
    setExpandedCRMData([]); // clear data when collapsing
  } else {
    setExpandedCRMIndex(index); // expand
    
    try {
      console.log('Fetching CRM details for:', item);
      
      // For ICAR, fetch ICAR-specific data using GetStateDashboarCount API
      if (item.userTypeName === "ICAR") {
        const result = await axios({
          method: 'post',
          url: `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetStateDashboarCount`,
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          },
          data: {
            "flag": "ICARDETAIL",
            "stateCode": parseInt(sessionStorage.getItem("stateNameModel")),
            "userTypeCode": 0
          }
        });
        
        console.log('ICAR Details API Response:', result.data);
        
        if (result.data.success && result.data.dataContent) {
          console.log('Setting ICAR expanded data:', result.data.dataContent);
          setExpandedCRMData(result.data.dataContent);
        } else {
          console.log('ICAR API response not successful or no data content:', result.data);
          setExpandedCRMData([]);
        }
      } 
      // For State, fetch State-specific data using standardized API
      else if (item.userTypeName === "State") {
        const result = await axios({
          method: 'post',
          url: `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetStateDashboarCount`,
          headers: {
            'accept': '/',
            'Content-Type': 'application/json'
          },
          data: {
            "flag": "State",
            "userTypeCode": sessionStorage.getItem("userTypeCodeModel"),
            "stateCode": sessionStorage.getItem("stateNameModel")
          }
        });
        
        console.log('State Details API Response:', result.data);
        
        if (result.data.success && result.data.dataContent) {
          console.log('Setting State expanded data:', result.data.dataContent);
          setExpandedCRMData(result.data.dataContent);
        } else {
          console.log('State API response not successful or no data content:', result.data);
          setExpandedCRMData([]);
        }
      }
    } catch (error) {
      console.error("Error fetching CRM details:", error);
      setExpandedCRMData([]);
    }
  }
};

// Function to handle FMTTI drill-down
const handleFMTTIToggle = async (index, item) => {
  if (expandedFMTTIIndex === index) {
    setExpandedFMTTIIndex(null); // collapse
    setExpandedFMTTIData([]); // clear data when collapsing
  } else {
    setExpandedFMTTIIndex(index); // expand
    
    try {
      console.log('Fetching FMTTI details for:', item);
      
      // For FMTTI, fetch FMTTI-specific data using standardized API
      if (item.userTypeName === "FMTTI") {
        const result = await axios({
          method: 'post',
          url: `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarReportCount`,
          headers: {
            'accept': '/',
            'Content-Type': 'application/json'
          },
          data: {
            "flag": "FMTTIUserRole",
            "userTypeCode": 0,
            "stateCode": 0
          }
        });
        
        console.log('FMTTI Details API Response:', result.data);
        
        if (result.data.success && result.data.dataContent) {
          setExpandedFMTTIData(result.data.dataContent);
        }
      }
    } catch (error) {
      console.error("Error fetching FMTTI details:", error);
      setExpandedFMTTIData([]);
    }
  }
};

// Function to handle State Admin User Type drill-down (Second level - District-wise)
const handleStateUserTypeToggle = async (index, roleItem, userType) => {
  if (expandedStateUserTypeIndex === index) {
    setExpandedStateUserTypeIndex(null); // collapse
    setExpandedStateUserTypeData([]); // clear data when collapsing
  } else {
    setExpandedStateUserTypeIndex(index); // expand
    
    try {
      console.log('Fetching District-wise details for role:', roleItem, userType);
      
      const stateCode = sessionStorage.getItem("stateNameModel");
      let flag = "";
      let userTypeCode = 0;
      
      // Determine the flag and userTypeCode based on role name
      if (roleItem.userRoleName === "ICAR" || roleItem.userTypeName === "ICAR") {
        flag = "ICARDETAIL";
        userTypeCode = 0;
        stateCode = sessionStorage.getItem("stateNameModel");
      } else if (roleItem.userRoleName === "State" || roleItem.userTypeName === "State") {
        flag = "State";
        userTypeCode = 2;
        stateCode=sessionStorage.getItem("stateNameModel");
      } else {
        // For other roles, use UserTypeDistrict with the role's userTypeCode
        flag = "UserTypeDistrict";
        userTypeCode = roleItem.userRoleCode || 0;
        stateCode=sessionStorage.getItem("stateNameModel");
      }
      
      const result = await axios({
        method: 'post',
        url: `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetStateDashboarCount`,
        headers: {
          'accept': '*/*',
          'Content-Type': 'application/json'
        },
        data: {
          "flag": flag,
          "stateCode": parseInt(stateCode),
          "userTypeCode": userTypeCode
        }
      });
      
      console.log('District-wise Details API Response:', result.data);
      
      if (result.data.success && result.data.dataContent) {
        setExpandedStateUserTypeData(result.data.dataContent);
      } else {
        setExpandedStateUserTypeData([]);
      }
    } catch (error) {
      console.error("Error fetching District-wise details:", error);
      setExpandedStateUserTypeData([]);
    }
  }
};

// Function to handle third drill-down (District details for State)
const handleStateDistrictToggle = async (index, stateItem) => {
  if (expandedStateDistrictIndex === index) {
    setExpandedStateDistrictIndex(null); // collapse
    setExpandedStateDistrictData([]); // clear data when collapsing
  } else {
    setExpandedStateDistrictIndex(index); // expand
    
    try {
      console.log('Fetching District details for state:', stateItem);
      
      // Determine userTypeCode based on the context (CRM = 2, SMAM = 3)
      const userTypeCode = stateItem.userTypeCode || 2; // Default to CRM if not specified
      const stateCode = stateItem.stateCode || parseInt(sessionStorage.getItem("stateNameModel"));
      
      console.log('District API Parameters:', {
        flag: "District",
        userTypeCode: userTypeCode,
        stateCode: stateCode
      });
      
      const result = await axios({
        method: 'post',
        url: `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarReportCount`,
        headers: {
          'accept': '/',
          'Content-Type': 'application/json'
        },
        data: {
          "flag": "District",
          "userTypeCode": userTypeCode,
          "stateCode": stateCode
        }
      });
      
      console.log('District Details API Response:', result.data);
      
      if (result.data.success && result.data.dataContent) {
        console.log('Setting District expanded data:', result.data.dataContent);
        setExpandedStateDistrictData(result.data.dataContent);
      } else {
        console.log('District API response not successful or no data content:', result.data);
        setExpandedStateDistrictData([]);
      }
    } catch (error) {
      console.error("Error fetching District details:", error);
      setExpandedStateDistrictData([]);
    }
  }
};

// Function to handle SMAM drill-down
const handleSMAMToggle = async (index, smamItem) => {
  if (expandedSMAMIndex === index) {
    setExpandedSMAMIndex(null); // collapse
    setExpandedSMAMData([]); // clear data when collapsing
  } else {
    setExpandedSMAMIndex(index); // expand
    
    try {
      console.log('Fetching State details for SMAM:', smamItem);
      
      const stateCode = sessionStorage.getItem("stateNameModel");
      
      const result = await axios({
        method: 'post',
        url: `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetStateDashboarCount`,
        headers: {
          'accept': '*/*',
          'Content-Type': 'application/json'
        },
        data: {
          "flag": "State",
          "stateCode": parseInt(sessionStorage.getItem("stateNameModel")),
          "userTypeCode": sessionStorage.getItem("userTypeCodeModel")
        }
      });
      
      console.log('SMAM State Details API Response:', result.data);
      
      if (result.data.success && result.data.dataContent) {
        setExpandedSMAMData(result.data.dataContent);
      } else {
        setExpandedSMAMData([]);
      }
    } catch (error) {
      console.error("Error fetching SMAM State details:", error);
      setExpandedSMAMData([]);
    }
  }
};

// Function to handle SMAM district drill-down
const handleSMAMDistrictToggle = async (index, stateItem) => {
  if (expandedSMAMDistrictIndex === index) {
    setExpandedSMAMDistrictIndex(null); // collapse
    setExpandedSMAMDistrictData([]); // clear data when collapsing
  } else {
    setExpandedSMAMDistrictIndex(index); // expand
    
    try {
      console.log('Fetching SMAM district details for state:', stateItem);
      console.log('State code being used:', stateItem.stateCode);
      
      const result = await axios({
        method: 'post',
        url: `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarReportCount`,
        headers: {
          'accept': '/',
          'Content-Type': 'application/json'
        },
        data: {
          "flag": "District",
          "userTypeCode": sessionStorage.getItem("userTypeCodeModel"),
          "stateCode": sessionStorage.getItem("stateNameModel")
        }
      });
      
      console.log('SMAM District Details API Response:', result.data);
      
      if (result.data.success && result.data.dataContent) {
        console.log('Setting SMAM District expanded data:', result.data.dataContent);
        setExpandedSMAMDistrictData(result.data.dataContent);
      } else {
        console.log('SMAM District API response not successful or no data content:', result.data);
        setExpandedSMAMDistrictData([]);
      }
    } catch (error) {
      console.error("Error fetching SMAM District details:", error);
      setExpandedSMAMDistrictData([]);
    }
  }
};

const handleRowToggles = async (index, survey) => {
  console.log("survey----------",survey.stateCode)
  
  setExpandedRowDatas([]);
  if (expandedRowIndexs === index) {
    setExpandedRowIndexs(null); // collapse
  } else {
    setExpandedRowIndexs(index); // expand
    const schemeCode = sessionStorage.getItem("schemeCodeModel");
    // only fetch if data not already loaded
    if (!expandedRowDatas[index]) {
      // Handle multiple districts for district code using helper function
      const districtCodeFromSession = sessionStorage.getItem("districtCodeModel");
      let districtCode;
      
      if (districtCodeFromSession && districtCodeFromSession.includes(',')) {
        // Multiple districts - send as comma-separated string
        districtCode = districtCodeFromSession;
      } else {
        // Single district - handle special case and convert to integer
        districtCode = districtCodeFromSession === "1" ? 0 : survey.districtCode;
      }
      
      const parm = {
        schemeCode,
        stateCode: survey.stateCode,
        str_FinYear: selectedFinYear === 'All' ? '' : selectedFinYear,
        districtCode: String(districtCode),
        subDistrictCode:'0',
        userLevel: sessionStorage.getItem("userTypeCodeModel") === "1"
          ? "2"
          : "3",
          userCode: sessionStorage.getItem("userCodeModel") || 0,
    };
      try {
        const { data } = await axios.post(
            `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/SurveyCountGroupWise/SurveysCountGroupWise`,
            parm
        );
        console.log("datadatadata", data.dataContent);
         setExpandedRowDatas(data.dataContent);
      
       
      } catch (error) {
          console.error("Error fetching  details:", error);
      }
    }
  }
};



  return (
    <>
      <AdminHeaderNew />
      <AdminSideBarMnt />
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Dashboard M&T</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">Admin</li>
              <li className="breadcrumb-item active">Dashboard</li>
              <li className="breadcrumb-item">{(sessionStorage.getItem("userNameModel"))}</li>
                            <li className="breadcrumb-item">
                                {(() => {
                                    const userTypeCode = Number(sessionStorage.getItem("userTypeCodeModel"));
                                    switch(userTypeCode) {
                                        case 1: return "FMTTI";
                                        //case 2: return "CRM";
                                        case 2: return `CRM${stateCodeNameMap[sessionStorage.getItem("stateNameModel")] ? " - " + stateCodeNameMap[sessionStorage.getItem("stateNameModel")] : (sessionStorage.getItem("currentStateName") ? " - " + sessionStorage.getItem("currentStateName") : "")}`;
                                       // case 3: return "SMAM";
                                        case 3: return `SMAM${stateCodeNameMap[sessionStorage.getItem("stateNameModel")] ? " - " + stateCodeNameMap[sessionStorage.getItem("stateNameModel")] : (sessionStorage.getItem("currentStateName") ? " - " + sessionStorage.getItem("currentStateName") : "")}`;
                                        default: return "";
                                    }
                                })()}
                            </li>
              {/* <li className="breadcrumb-item">{(sessionStorage.getItem("userTypeCodeModel"))}</li> */}
            </ol>
          </nav>
        </div>
        <div
          className="row mb-4 flitertag justify-content-end"
          style={{ marginTop: "-48px" }}
        >
          
         <div className="col-md-3">
          {sessionStorage.getItem("userRoleCodeModel") === "1" && (
            <div className="form-group text-white">
              
              <label htmlFor="finYear" className="form-label text-white">
                Financial Year
              </label>
              <select
                id="finYear"
                className="form-select finacildd_labelbox"
                value={selectedFinYear}
                onChange={(e) => setSelectedFinYear(e.target.value)}
                style={{
                  border: "1px solid white",
                  color: "white",
                  height: "36px",
                }}
              >
                {finYears.map((year) => (
                  <option key={year} value={year} style={{ color: "black" }}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
            )}
          </div>
          
          </div>
        <section className="section dashboard">
          <div className='row'>
            {sessionStorage.getItem("userRoleCodeModel") === "1" ? (
              <CentralLoginDashboard
                loading={loading}
                finYearFilter={selectedFinYear}
              />
            ) : (
              <>
                {(sessionStorage.getItem("userRoleCodeModel") === "5" || sessionStorage.getItem("userRoleCodeModel") === "8" || sessionStorage.getItem("userRoleCodeModel") === "12") && (
                  <SurveyorLoginDashboard
                    loading={loading}
                    crmDemoCount={crmDemoCount}
                    chcHistoryCount={chcHistoryCount}
                    handleMoreInfoClick={handleMoreInfoClick}
                  />
                )}

                {sessionStorage.getItem("userRoleCodeModel") === "2" && (
              <StateLoginDashboard
                loading={loading}
                handleMoreInfoClick={handleMoreInfoClick}
              />
                )}

                {(sessionStorage.getItem("userRoleCodeModel") === "3" || 
                  sessionStorage.getItem("userRoleCodeModel") === "18") && (
                  <DistrictLoginDashboard
                    loading={loading}
                    handleMoreInfoClick={handleMoreInfoClick}
                  />
                )}
              </>
            )}
            {sessionStorage.getItem("userRoleCodeModel") === "6" && (
              <FmttiDashboard
                loading={loading}
                handleMoreInfoClick={handleMoreInfoClick}
              />
            )}
            {sessionStorage.getItem("userRoleCodeModel") === "9" && (
              <IcarDashboard
                loading={loading}
                handleMoreInfoClick={handleMoreInfoClick}
              />
            )}
            {sessionStorage.getItem("userRoleCodeModel") === "10" && (
              <AtariDashboard
                loading={loading}
                handleMoreInfoClick={handleMoreInfoClick}
              />
            )}
           {sessionStorage.getItem("userRoleCodeModel") === "11" && (
              <KVKDashboard
                loading={loading}
                handleMoreInfoClick={handleMoreInfoClick}
              />
            )}
           
                {sessionStorage.getItem("userRoleCodeModel") === "7" && (
                  <>
                    <div className="col-xxl-6 col-xl-6">
                      <div className="card info-card sales-card bg-gradient-danger card-img-holder">
                        <div className="card-body">
                          <img src={Circles} className="card-img-absolute" alt="circle-image" />
                          <h5 className="card-title">Active User</h5>
                          <div className="d-flex align-items-center">
                            <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                              <i><FontAwesomeIcon icon={faUsers} /> </i>
                            </div>
                            <div className="ps-3">
                              <h6 id="recordCount">{loading ? 'Loading...' : role7UserCount}</h6>
                            </div>
                          </div>
                          <div className="mt-3">
                            <button 
                              className='btn btn-link p-0 text-white' 
                              onClick={() => handleMoreInfoClick('role7')}
                              title="Click for more information"
                            >
                              <i className="bi bi-arrow-right-circle-fill fs-6">More Info</i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    
                  </>
                )}
            </div>

            {/* Detailed Tables Section */}
            <div className="row usercount">
              {userVisible && (
                <div className="col-lg-12" id="user-details-table">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Active Users Details</h5>
                      <div className="d-flex justify-content-end mb-2">
                        <button className="btn btn-sm btn-success" onClick={exportUserData}>
                          Export CSV
                        </button>
                      </div>
                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>Sr. No.</th>
                              {/* <th>User Name</th>
                              <th>Email</th>
                              <th>Mobile</th>*/}
                              {/* <th>Component</th>  */}
                               {sessionStorage.getItem("userRoleCodeModel") === "1" && <th>Role</th>}
                               {(sessionStorage.getItem("userRoleCodeModel") === "2" || sessionStorage.getItem("userRoleCodeModel") === "3") && <th>User Type</th>}
                              
                              <th>User Count</th>
                            {((sessionStorage.getItem("userRoleCodeModel") === "1") || 
                             (sessionStorage.getItem("userRoleCodeModel") === "2") || 
                             (sessionStorage.getItem("userRoleCodeModel") === "3")) &&
                            <th style={{width: "50px", textAlign: "center"}}>Action</th>
                          }
                            </tr>
                          </thead>
                          <tbody>
                            {userDetails && userDetails.length > 0 ? (
                              userDetails.map((user, index) => (
                                <React.Fragment key={index}>
                                  <tr>
                                    <td>{index + 1}</td>
                                    {/* <td>{user.userName || 'N/A'}</td>
                                    <td>{user.emailId || 'N/A'}</td>
                                    <td>{user.mobileNo || 'N/A'}</td> */}
                                    {sessionStorage.getItem("userRoleCodeModel") === "1" && <td>{user.roleName || user.userTypeName || 'N/A'}</td>}
                                    {(sessionStorage.getItem("userRoleCodeModel") === "2" || sessionStorage.getItem("userRoleCodeModel") === "3") && <td>{user.userTypeName || 'N/A'}</td>}
                                    <td>{user.totalUsers || 0}</td>

                                      {((sessionStorage.getItem("userRoleCodeModel") === "1") || 
                                       (sessionStorage.getItem("userRoleCodeModel") === "2") || 
                                       (sessionStorage.getItem("userRoleCodeModel") === "3")) &&
                                    <td style={{textAlign: "center"}}>
                                      <span 
                                        role="button"
                                        onClick={() => handleRowToggle(index, user)}
                                        style={{
                                          cursor: "pointer",
                                          color: "#0d6efd",
                                          fontSize: "16px",
                                          fontWeight: "bold"
                                        }}
                                      >
                                        {expandedRowIndex === index ? "-" : "+"}
                                      </span>
                                    </td>
}
                                  </tr>
                                  
                                  {/* Expanded row content - dynamic based on user type */}
                                  {expandedRowIndex === index && ((expandedRowData && expandedRowData.length > 0) || (expandedSMAMData && expandedSMAMData.length > 0)) && (
                                    <tr>
                                      <td colSpan={(sessionStorage.getItem("userRoleCodeModel") === "1") ? 4 : 
                                                   (sessionStorage.getItem("userRoleCodeModel") === "2" || sessionStorage.getItem("userRoleCodeModel") === "3") ? 4 : 3}>
                                        <div className="mt-2 p-3 bg-light">
                                          <h6 className="mb-3">
                                            {user.roleName === "CRM" || user.userTypeName === "CRM" ? "CRM User Types:" : 
                                             user.roleName === "SMAM" || user.userTypeName === "SMAM" ? "State-wise Details:" : 
                                             user.roleName === "FMTTI" || user.userTypeName === "FMTTI" ? "FMTTI User Roles:" :
                                             "Details:"}
                                          </h6>
                                          
                                          {/* For CRM, show user types data */}
                                          {(user.roleName === "CRM" || user.userTypeName === "CRM") && expandedRowData && expandedRowData.length > 0 ? (
                                            <div>
                                              <div className="d-flex justify-content-end mb-2">
                                                <button className="btn btn-sm btn-success" onClick={exportExpandedRowData}>
                                                  Export CSV
                                                </button>
                                              </div>
                                              <table className="table table-sm table-bordered mb-0">
                                                <thead>
                                                  <tr>
                                                    <th>Sr. No.</th>
                                                    <th>CRM Users</th>
                                                    <th>User Count</th>
                                                    <th>Action</th>
                                                  </tr>
                                                </thead>
                                              <tbody>
                                                {expandedRowData.map((item, idx) => (
                                                  <React.Fragment key={idx}>
                                                    <tr>
                                                      <td>{idx + 1}</td>
                                                      <td>{item.stateName || 'N/A'}</td>
                                                      <td>{item.totalUsers || item.recordCount || 0}</td>
                                                      <td>
                                                          <span 
                                                            role="button"
                                                            onClick={() => handleCRMToggle(idx, item)}
                                                            style={{
                                                              cursor: "pointer",
                                                              color: "#0d6efd",
                                                              fontSize: "12px",
                                                              fontWeight: "bold"
                                                            }}
                                                            title="Click for more details"
                                                          >
                                                            {expandedCRMIndex === idx ? "-" : "+"}
                                                          </span>
                                                        </td>
                                                    </tr>
                                                    
                                                    {/* CRM drill-down details */}
                                                    {expandedCRMIndex === idx && (
                                                      <tr>
                                                        <td colSpan={4}>
                                                          <div className="mt-2 p-2 bg-light">
                                                            <h6 className="mb-2">{item.userTypeName} Details:</h6>
                                                            
                                                            {expandedCRMData && expandedCRMData.length > 0 ? (
                                                              <div>
                                                                <div className="d-flex justify-content-end mb-2">
                                                                  <button className="btn btn-sm btn-success" onClick={exportExpandedCRMData}>
                                                                    Export CSV
                                                                  </button>
                                                                </div>
                                                                <table className="table table-sm table-bordered mb-0">
                                                                <thead>
                                                                  <tr>
                                                                    <th>Sr. No.</th>
                                                                    {item.userTypeName === "ICAR" ? (
                                                                      <>
                                                                        <th>Role Name</th>
                                                                        <th>User Count</th>
                                                                      </>
                                                                    ) : (
                                                                      <>
                                                                        <th>State Name</th>
                                                                        <th>User Count</th>
                                                                        {item.userTypeName === "State" && <th>Action</th>}
                                                                      </>
                                                                    )}
                                                                  </tr>
                                                                </thead>
                                                              <tbody>
                                                                {expandedCRMData.map((detailItem, detailIdx) => (
                                                                  <React.Fragment key={detailIdx}>
                                                                    <tr>
                                                                      <td>{detailIdx + 1}</td>
                                                                      {item.userTypeName === "ICAR" ? (
                                                                        <>
                                                                          <td>{detailItem.userRoleName || 'N/A'}</td>
                                                                          <td>{detailItem.totalUsers || 0}</td>
                                                                        </>
                                                                      ) : (
                                                                        <>
                                                                          <td>{detailItem.stateName || 'N/A'}</td>
                                                                          <td>{detailItem.totalUsers || 0}</td>
                                                                          {item.userTypeName === "State" && (
                                                                            <td>
                                                                              <span 
                                                                                role="button"
                                                                                onClick={() => handleStateDistrictToggle(detailIdx, {...detailItem, userTypeCode: 2})}
                                                                                style={{
                                                                                  cursor: "pointer",
                                                                                  color: "#0d6efd",
                                                                                  fontSize: "12px",
                                                                                  fontWeight: "bold"
                                                                                }}
                                                                                title="Click for district details"
                                                                              >
                                                                                {expandedStateDistrictIndex === detailIdx ? "-" : "+"}
                                                                              </span>
                                                                            </td>
                                                                          )}
                                                                        </>
                                                                      )}
                                                                    </tr>
                                                                    
                                                                    {/* Third drill-down - District details for State */}
                                                                    {item.userTypeName === "State" && expandedStateDistrictIndex === detailIdx && (
                                                                      <tr>
                                                                        <td colSpan={3}>
                                                                          <div className="mt-2 p-2 bg-light">
                                                                            <h6 className="mb-2">District Details for {detailItem.stateName}:</h6>
                                                                            {expandedStateDistrictData && expandedStateDistrictData.length > 0 ? (
                                                                              <div>
                                                                                <div className="d-flex justify-content-end mb-2">
                                                                                  <button className="btn btn-sm btn-success" onClick={exportExpandedStateDistrictData}>
                                                                                    Export CSV
                                                                                  </button>
                                                                                </div>
                                                                                <table className="table table-sm table-bordered mb-0">
                                                                                <thead>
                                                                                  <tr>
                                                                                    <th>Sr. No.</th>
                                                                                    <th>District Name</th>
                                                                                    <th>User Count</th>
                                                                                  </tr>
                                                                                </thead>
                                                                              <tbody>
                                                                                {expandedStateDistrictData.map((districtItem, districtIdx) => (
                                                                                  <tr key={districtIdx}>
                                                                                    <td>{districtIdx + 1}</td>
                                                                                    <td>{districtItem.districtNames || 'N/A'}</td>
                                                                                    <td>{districtItem.totalUsers || 0}</td>
                                                                                  </tr>
                                                                                ))}
                                                                              </tbody>
                                                                              </table>
                                                                              </div>
                                                                            ) : (
                                                                              <div className="text-center p-3">
                                                                                <p className="mb-0 text-muted">No district data available or loading...</p>
                                                                              </div>
                                                                            )}
                                                                          </div>
                                                                        </td>
                                                                      </tr>
                                                                    )}
                                                                  </React.Fragment>
                                                                ))}
                                                              </tbody>
                                                              </table>
                                                              </div>
                                                            ) : (
                                                              <div className="text-center p-3">
                                                                <p className="mb-0 text-muted">No data available or loading...</p>
                                                              </div>
                                                            )}
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    )}
                                                  </React.Fragment>
                                                ))}
                                              </tbody>
                                              </table>
                                            </div>
                                          ) : (user.roleName === "FMTTI" || user.userTypeName === "FMTTI") && expandedRowData && expandedRowData.length > 0 ? (
                                            <div>
                                              <div className="d-flex justify-content-end mb-2">
                                                <button className="btn btn-sm btn-success" onClick={exportExpandedRowData}>
                                                  Export CSV
                                                </button>
                                              </div>
                                              <table className="table table-sm table-bordered mb-0">
                                                <thead>
                                                  <tr>
                                                    <th>Sr. No.</th>
                                                    <th>Role Name</th>
                                                    <th>User Count</th>
                                                    {/* <th>Action</th> */}
                                                  </tr>
                                                </thead>
                                              <tbody>
                                                {expandedRowData.map((item, idx) => (
                                                  <React.Fragment key={idx}>
                                                    <tr>
                                                      <td>{idx + 1}</td>
                                                      <td>{item.userTypeName || 'N/A'}</td>
                                                      <td>{item.totalUsers || item.recordCount || 0}</td>
                                                      {/* <td>
                                                          <span 
                                                            role="button"
                                                            onClick={() => handleFMTTIToggle(idx, item)}
                                                            style={{
                                                              cursor: "pointer",
                                                              color: "#0d6efd",
                                                              fontSize: "12px",
                                                              fontWeight: "bold"
                                                            }}
                                                            title="Click for more details"
                                                          >
                                                            {expandedFMTTIIndex === idx ? "-" : "+"}
                                                          </span>
                                                        </td> */}
                                                    </tr>
                                                    
                                                    {/* FMTTI drill-down details */}
                                                    {expandedFMTTIIndex === idx && expandedFMTTIData && expandedFMTTIData.length > 0 && (
                                                      <tr>
                                                        <td colSpan={4}>
                                                          <div className="mt-2 p-2 bg-light">
                                                            <h6 className="mb-2">{item.userTypeName} Details:</h6>
                                                            <table className="table table-sm table-bordered mb-0">
                                                              <thead>
                                                                <tr>
                                                                  <th>Sr. No.</th>
                                                                  <th>Role Name</th>
                                                                  <th>User Count</th>
                                                                </tr>
                                                              </thead>
                                                              <tbody>
                                                                {expandedFMTTIData.map((detailItem, detailIdx) => (
                                                                  <tr key={detailIdx}>
                                                                    <td>{detailIdx + 1}</td>
                                                                    <td>{detailItem.userRoleName || 'N/A'}</td>
                                                                    <td>{detailItem.totalUsers || 0}</td>
                                                                  </tr>
                                                                ))}
                                                              </tbody>
                                                            </table>
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    )}
                                                  </React.Fragment>
                                                ))}
                                              </tbody>
                                              </table>
                                            </div>
                                          ) : (expandedSMAMData && expandedSMAMData.length > 0 && (user.roleName === "SMAM" || user.userTypeName === "SMAM" || user.roleName?.includes("SMAM") || user.userTypeName?.includes("SMAM"))) ? (
                                            <div>
                                              <div className="d-flex justify-content-end mb-2">
                                                <button className="btn btn-sm btn-success" onClick={exportExpandedSMAMData}>
                                                  Export CSV
                                                </button>
                                              </div>
                                              <table className="table table-sm table-bordered mb-0">
                                                <thead>
                                                  <tr>
                                                    <th>Sr. No.</th>
                                                    <th>{expandedSMAMData && expandedSMAMData.length > 0 ? 'State Name' : 'Role Name'}</th>
                                                  <th>User Count</th>
                                                  <th>Action</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {(() => {
                                                  const dataToRender = expandedRowData && expandedRowData.length > 0 ? expandedRowData : expandedSMAMData;
                                                  console.log('Data to render in table:', dataToRender);
                                                  return dataToRender;
                                                })().map((roleItem, roleIdx) => (
                                                  <React.Fragment key={roleIdx}>
                                                    <tr>
                                                      <td>{roleIdx + 1}</td>
                                                      <td>{expandedSMAMData && expandedSMAMData.length > 0 ? (roleItem.stateName || 'N/A') : (roleItem.userRoleName || 'N/A')}</td>
                                                      <td>{roleItem.totalUsers || 0}</td>
                                                      <td>
                                                        <span 
                                                          role="button"
                                                          onClick={() => expandedSMAMData && expandedSMAMData.length > 0 ? handleSMAMDistrictToggle(roleIdx, roleItem) : handleStateUserTypeToggle(roleIdx, roleItem, user)}
                                                          style={{
                                                            cursor: "pointer",
                                                            color: "#0d6efd",
                                                            fontSize: "12px",
                                                            fontWeight: "bold"
                                                          }}
                                                          title="Click for district-wise details"
                                                        >
                                                          {expandedSMAMData && expandedSMAMData.length > 0 ? (expandedSMAMDistrictIndex === roleIdx ? "-" : "+") : (expandedStateUserTypeIndex === roleIdx ? "-" : "+")}
                                                        </span>
                                                      </td>
                                                    </tr>
                                                    
                                                    {/* State User Type drill-down details - District-wise */}
                                                    {expandedStateUserTypeIndex === roleIdx && (
                                                      <tr>
                                                        <td colSpan={4}>
                                                          <div className="mt-2 p-2 bg-light">
                                                            <h6 className="mb-2">{roleItem.userRoleName} District-wise Details:</h6>
                                                            {expandedStateUserTypeData && expandedStateUserTypeData.length > 0 ? (
                                                              <div>
                                                                <div className="d-flex justify-content-end mb-2">
                                                                  <button className="btn btn-sm btn-success" onClick={exportExpandedStateUserTypeData}>
                                                                    Export CSV
                                                                  </button>
                                                                </div>
                                                                <table className="table table-sm table-bordered mb-0">
                                                                  <thead>
                                                                    <tr>
                                                                      <th>Sr. No.</th>
                                                                      <th>District Name</th>
                                                                      <th>User Count</th>
                                                                    </tr>
                                                                  </thead>
                                                                <tbody>
                                                                  {expandedStateUserTypeData.map((districtItem, districtIdx) => (
                                                                    <tr key={districtIdx}>
                                                                      <td>{districtIdx + 1}</td>
                                                                      <td>{districtItem.districtName || 'N/A'}</td>
                                                                      <td>{districtItem.totalUsers || 0}</td>
                                                                    </tr>
                                                                  ))}
                                                                </tbody>
                                                                </table>
                                                                </div>
                                                            ) : (
                                                              <div className="text-center p-3">
                                                                <p className="mb-0 text-muted">No data available or loading...</p>
                                                              </div>
                                                            )}
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    )}
                                                    
                                                    {/* SMAM district drill-down details */}
                                                    {expandedSMAMData && expandedSMAMData.length > 0 && expandedSMAMDistrictIndex === roleIdx && (
                                                      <tr>
                                                        <td colSpan={4}>
                                                          <div className="mt-2 p-2 bg-light">
                                                            <h6 className="mb-2">District-wise Details for {roleItem.stateName}:</h6>
                                                           
                                                            {expandedSMAMDistrictData && expandedSMAMDistrictData.length > 0 ? (
                                                              <div>
                                                                <div className="d-flex justify-content-end mb-2">
                                                                  <button className="btn btn-sm btn-success" onClick={exportExpandedSMAMDistrictData}>
                                                                    Export CSV
                                                                  </button>
                                                                </div>
                                                                <table className="table table-sm table-bordered mb-0">
                                                                  <thead>
                                                                    <tr>
                                                                      <th>Sr. No.</th>
                                                                      <th>District Name</th>
                                                                      <th>User Count</th>
                                                                    </tr>
                                                                  </thead>
                                                                <tbody>
                                                                  {expandedSMAMDistrictData.map((districtItem, districtIdx) => (
                                                                    <tr key={districtIdx}>
                                                                      <td>{districtIdx + 1}</td>
                                                                      <td>{districtItem.districtName || districtItem.districtNames || 'N/A'}</td>
                                                                      <td>{districtItem.totalUsers || districtItem.total || 0}</td>
                                                                    </tr>
                                                                  ))}
                                                                </tbody>
                                                                </table>
                                                                </div>
                                                            ) : (
                                                              <div className="text-center p-3">
                                                                <p className="mb-0 text-muted">No district data available or loading...</p>
                                                                <button 
                                                                  className="btn btn-sm btn-primary mt-2"
                                                                  onClick={() => handleSMAMDistrictToggle(roleIdx, roleItem)}
                                                                  title="Click to load district details"
                                                                >
                                                                  Load District Details
                                                                </button>
                                                              </div>
                                                            )}
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    )}
                                                  </React.Fragment>
                                                ))}
                                              </tbody>
                                            </table>
                                            </div>
                                          ) : ((sessionStorage.getItem("userRoleCodeModel") === "2" || sessionStorage.getItem("userRoleCodeModel") === "3") && (expandedRowData && expandedRowData.length > 0) && !(user.roleName === "CRM" || user.userTypeName === "CRM") && !(user.roleName === "SMAM" || user.userTypeName === "SMAM")) ? (
                                            <div>
                                              <div className="d-flex justify-content-end mb-2">
                                                <button className="btn btn-sm btn-success" onClick={exportExpandedRowData}>
                                                  Export CSV
                                                </button>
                                              </div>
                                              <table className="table table-sm table-bordered mb-0">
                                                <thead>
                                                  <tr>
                                                    <th>Sr. No.</th>
                                                    <th>{expandedSMAMData && expandedSMAMData.length > 0 ? 'State Name' : 'Role Name'}</th>
                                                    <th>User Count</th>
                                                    <th>Action</th>
                                                  </tr>
                                                </thead>
                                              <tbody>
                                                {(() => {
                                                  const dataToRender = expandedRowData && expandedRowData.length > 0 ? expandedRowData : expandedSMAMData;
                                                  console.log('Data to render in table:', dataToRender);
                                                  return dataToRender;
                                                })().map((roleItem, roleIdx) => (
                                                  <React.Fragment key={roleIdx}>
                                                    <tr>
                                                      <td>{roleIdx + 1}</td>
                                                      <td>{expandedSMAMData && expandedSMAMData.length > 0 ? (roleItem.stateName || 'N/A') : (roleItem.userRoleName || 'N/A')}</td>
                                                      <td>{roleItem.totalUsers || 0}</td>
                                                      <td>
                                                        <span 
                                                          role="button"
                                                          onClick={() => expandedSMAMData && expandedSMAMData.length > 0 ? handleSMAMDistrictToggle(roleIdx, roleItem) : handleStateUserTypeToggle(roleIdx, roleItem, user)}
                                                          style={{
                                                            cursor: "pointer",
                                                            color: "#0d6efd",
                                                            fontSize: "12px",
                                                            fontWeight: "bold"
                                                          }}
                                                          title="Click for district-wise details"
                                                        >
                                                          {expandedSMAMData && expandedSMAMData.length > 0 ? (expandedSMAMDistrictIndex === roleIdx ? "-" : "+") : (expandedStateUserTypeIndex === roleIdx ? "-" : "+")}
                                                        </span>
                                                      </td>
                                                    </tr>
                                                    
                                                    {/* State User Type drill-down details - District-wise */}
                                                    {expandedStateUserTypeIndex === roleIdx && (
                                                      <tr>
                                                        <td colSpan={4}>
                                                          <div className="mt-2 p-2 bg-light">
                                                            <h6 className="mb-2">{roleItem.userRoleName} District-wise Details:</h6>
                                                            {expandedStateUserTypeData && expandedStateUserTypeData.length > 0 ? (
                                                              <div>
                                                                <div className="d-flex justify-content-end mb-2">
                                                                  <button className="btn btn-sm btn-success" onClick={exportExpandedStateUserTypeData}>
                                                                    Export CSV
                                                                  </button>
                                                                </div>
                                                                <table className="table table-sm table-bordered mb-0">
                                                                  <thead>
                                                                    <tr>
                                                                      <th>Sr. No.</th>
                                                                      <th>District Name</th>
                                                                      <th>User Count</th>
                                                                    </tr>
                                                                  </thead>
                                                                <tbody>
                                                                  {expandedStateUserTypeData.map((districtItem, districtIdx) => (
                                                                    <tr key={districtIdx}>
                                                                      <td>{districtIdx + 1}</td>
                                                                      <td>{districtItem.districtName || 'N/A'}</td>
                                                                      <td>{districtItem.totalUsers || 0}</td>
                                                                    </tr>
                                                                  ))}
                                                                </tbody>
                                                                </table>
                                                                </div>
                                                            ) : (
                                                              <div className="text-center p-3">
                                                                <p className="mb-0 text-muted">No data available or loading...</p>
                                                              </div>
                                                            )}
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    )}
                                                  </React.Fragment>
                                                ))}
                                              </tbody>
                                              </table>
                                            </div>
                                          ) : (
                                            /* For other user types, show the original expanded data */
                                            <div>
                                              <div className="d-flex justify-content-end mb-2">
                                                <button className="btn btn-sm btn-success" onClick={exportExpandedRowData}>
                                                  Export CSV
                                                </button>
                                              </div>
                                              <table className="table table-sm table-bordered mb-0">
                                              <thead>
                                                <tr>
                                                  <th>Sr. No.</th>
                                                  <th>
                                                    {user.roleName === "SMAM" || user.userTypeName === "SMAM" ? "State" : "User Type"}
                                                  </th>
                                                  <th>Count</th>
                                                  <th>Action</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {expandedRowData.map((item, idx) => (
                                                  <React.Fragment key={idx}>
                                                    <tr>
                                                      <td>{idx + 1}</td>
                                                      <td>
                                                        {user.roleName === "SMAM" || user.userTypeName === "SMAM" 
                                                          ? (item.stateName || 'N/A')
                                                          : (item.userTypeName || item.userRoleName || 'N/A')
                                                        }
                                                      </td>
                                                      <td>
                                                        {user.roleName === "SMAM" || user.userTypeName === "SMAM" 
                                                          ? (item.totalUsers || 0)
                                                          : (item.recordCount || 0)
                                                        }
                                                      </td>
                                                      <td>
                                                        <span 
                                                          role="button"
                                                          onClick={() => handleStateToggle(idx, item)}
                                                          style={{
                                                            cursor: "pointer",
                                                            color: "#0d6efd",
                                                            fontSize: "14px",
                                                            fontWeight: "bold"
                                                          }}
                                                          title="Click for state-wise details"
                                                        >
                                                          {expandedStateIndex === idx ? "-" : "+"}
                                                        </span>
                                                      </td>
                                                    </tr>
                                                    
                                                    {/* Second level drill-down - State-wise details */}
                                                    {expandedStateIndex === idx && expandedStateData && expandedStateData.length > 0 && (
                                                      <tr>
                                                        <td colSpan={4}>
                                                          <div className="mt-2 p-2 bg-white">
                                                            <h6 className="mb-2">State-wise Details:</h6>
                                                            <table className="table table-sm table-bordered mb-0">
                                                              <thead>
                                                                <tr>
                                                                  <th>Sr. No.</th>
                                                                  <th>State Name</th>
                                                                  <th>User Count</th>
                                                                  <th>Action</th>
                                                                </tr>
                                                              </thead>
                                                              <tbody>
                                                                {expandedStateData.map((stateItem, stateIdx) => (
                                                                  <React.Fragment key={stateIdx}>
                                                                    <tr>
                                                                      <td>{stateIdx + 1}</td>
                                                                      <td>{stateItem.stateName || 'N/A'}</td>
                                                                      <td>{stateItem.totalUsers || 0}</td>
                                                                      <td>
                                                                        <span 
                                                                          role="button"
                                                                          onClick={() => handleDistrictToggle(stateIdx, stateItem)}
                                                                          style={{
                                                                            cursor: "pointer",
                                                                            color: "#0d6efd",
                                                                            fontSize: "12px",
                                                                            fontWeight: "bold"
                                                                          }}
                                                                          title="Click for district-wise details"
                                                                        >
                                                                          {expandedDistrictIndex === stateIdx ? "-" : "+"}
                                                                        </span>
                                                                      </td>
                                                                    </tr>
                                                                    
                                                                    {/* Third level drill-down - District-wise details */}
                                                                    {expandedDistrictIndex === stateIdx && expandedDistrictData && expandedDistrictData.length > 0 && (
                                                                      <tr>
                                                                        <td colSpan={4}>
                                                                          <div className="mt-2 p-2 bg-light">
                                                                            <h6 className="mb-2">District-wise Details:</h6>
                                                                            <div>
                                                                              <div className="d-flex justify-content-end mb-2">
                                                                                <button className="btn btn-sm btn-success" onClick={exportExpandedDistrictData}>
                                                                                  Export CSV
                                                                                </button>
                                                                              </div>
                                                                              <table className="table table-sm table-bordered mb-0">
                                                                                <thead>
                                                                                  <tr>
                                                                                    <th>Sr. No.</th>
                                                                                    <th>District Name</th>
                                                                                    <th>Count</th>
                                                                                  </tr>
                                                                                </thead>
                                                                              <tbody>
                                                                                {expandedDistrictData.map((districtItem, districtIdx) => (
                                                                                  <tr key={districtIdx}>
                                                                                    <td>{districtIdx + 1}</td>
                                                                                    <td>{districtItem.districtNames || 'N/A'}</td>
                                                                                    <td>{districtItem.totalUsers || 0}</td>
                                                                                  </tr>
                                                                                ))}
                                                                              </tbody>
                                                                              </table>
                                                                              </div>
                                                                            </div>
                                                                        </td>
                                                                      </tr>
                                                                    )}
                                                                  </React.Fragment>
                                                                ))}
                                                              </tbody>
                                                            </table>
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    )}
                                                  </React.Fragment>
                                                ))}
                                              </tbody>
                                              </table>
                                            </div>
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={(sessionStorage.getItem("userTypeCodeModel") === "1" && sessionStorage.getItem("userRoleCodeModel")==="2") ? 5 : 
                                             (sessionStorage.getItem("userTypeCodeModel") === "2" || sessionStorage.getItem("userTypeCodeModel") === "3") ? 4 : 3} className="text-center">No user data available</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {crmVisible && (
                <div className="col-lg-12" id="crm-details-table">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">CRM CHC Details</h5>
                      <div className="d-flex justify-content-end mb-2">
                        <button className="btn btn-sm btn-success" onClick={exportCRMData}>
                          Export CSV
                        </button>
                      </div>
                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>Sr. No.</th>
                              <th>State</th>
                              <th>User Count</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {crmChcDetails && crmChcDetails.length > 0 ? (
                              crmChcDetails.map((crm, index) => (
                                <React.Fragment key={index}>
                                  <tr>
                                    <td>{index + 1}</td>
                                    <td>{crm.stateName || 'N/A'}</td>
                                    <td>{crm.total || 0}</td>
                                    <td>
                                      <span 
                                        role="button"
                                        onClick={() => handleCHCDistrictToggle(index, crm)}
                                        style={{
                                          cursor: "pointer",
                                          color: "#0d6efd",
                                          fontSize: "12px",
                                          fontWeight: "bold"
                                        }}
                                        title="Click for district-wise details"
                                      >
                                        {expandedChcStateIndex === index ? "-" : "+"}
                                      </span>
                                    </td>
                                  </tr>
                                  {expandedChcStateIndex === index && (
                                    <tr>
                                      <td colSpan={4}>
                                        <div className="ms-4">
                                          <h6 className="mb-2">District-wise CHC Details for {crm.stateName}</h6>
                                          {expandedChcDistrictData.length > 0 ? (
                                            <div>
                                              <div className="d-flex justify-content-end mb-2">
                                                <button className="btn btn-sm btn-success" onClick={exportExpandedChcDistrictData}>
                                                  Export CSV
                                                </button>
                                              </div>
                                              <div className="table-responsive">
                                                <table className="table table-sm table-bordered">
                                                  <thead>
                                                    <tr>
                                                      <th>Sr. No.</th>
                                                      <th>District</th>
                                                      <th>User Count</th>
                                                    </tr>
                                                  </thead>
                                                <tbody>
                                                  {expandedChcDistrictData.map((districtItem, districtIdx) => (
                                                    <tr key={districtIdx}>
                                                      <td>{districtIdx + 1}</td>
                                                      <td>{districtItem.districtNames || 'N/A'}</td>
                                                      <td>{districtItem.total || 0}</td>
                                                    </tr>
                                                  ))}
                                                </tbody>
                                                </table>
                                              </div>
                                            </div>
                                          ) : (
                                            <div className="text-center p-3">
                                              <p className="mb-0 text-muted">No district data available or loading...</p>
                                              <button 
                                                className="btn btn-sm btn-primary mt-2"
                                                onClick={() => handleCHCDistrictToggle(index, crm)}
                                                title="Click to load district details"
                                              >
                                                Load District Details
                                              </button>
                                            </div>
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={4} className="text-center">No CRM CHC data available</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {fmttiVisible && (
                <div className="col-lg-12" id="fmtti-details-table">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">FMTTI Demonstration Details</h5>
                      <div className="d-flex justify-content-end mb-2">
                        <button className="btn btn-sm btn-success" onClick={exportFMTTIData}>
                          Export CSV
                        </button>
                      </div>
                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>Sr. No.</th>
                              <th>State</th>
                              <th>Count</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {fmttiStateDetails && fmttiStateDetails.length > 0 ? (
                              fmttiStateDetails.map((fmtti, index) => (
                                <React.Fragment key={index}>
                                  <tr>
                                    <td>{index + 1}</td>
                                    <td>{fmtti.stateName || 'N/A'}</td>
                                    <td>{fmtti.total || 0}</td>
                                    <td>
                                      <span 
                                        role="button"
                                        onClick={() => handleFMTTIDistrictToggle(index, fmtti)}
                                        style={{
                                          cursor: "pointer",
                                          color: "#0d6efd",
                                          fontSize: "12px",
                                          fontWeight: "bold"
                                        }}
                                        title="Click for district-wise details"
                                      >
                                        {expandedFmttiStateIndex === index ? "-" : "+"}
                                      </span>
                                    </td>
                                  </tr>
                                  {expandedFmttiStateIndex === index && expandedFmttiDistrictData.length > 0 && (
                                    <tr>
                                      <td colSpan={4}>
                                        <div className="ms-4">
                                          <h6 className="mb-2">District-wise FMTTI Details for {fmtti.stateName}</h6>
                                          <div>
                                            <div className="d-flex justify-content-end mb-2">
                                              <button className="btn btn-sm btn-success" onClick={exportExpandedFmttiDistrictData}>
                                                Export CSV
                                              </button>
                                            </div>
                                            <div className="table-responsive">
                                              <table className="table table-sm table-bordered">
                                                <thead>
                                                  <tr>
                                                    <th>Sr. No.</th>
                                                    <th>District</th>
                                                    <th>Count</th>
                                                  </tr>
                                                </thead>
                                              <tbody>
                                                {expandedFmttiDistrictData.map((districtItem, districtIdx) => (
                                                  <tr key={districtIdx}>
                                                    <td>{districtIdx + 1}</td>
                                                    <td>{districtItem.districtNames || 'N/A'}</td>
                                                    <td>{districtItem.total || 0}</td>
                                                  </tr>
                                                ))}
                                              </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={4} className="text-center">No FMTTI demonstration data available</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {smamVisible && (
                <div className="col-lg-12" id="smam-details-table">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">SMAM CHC Details</h5>
                      <div className="d-flex justify-content-end mb-2">
                        <button className="btn btn-sm btn-success" onClick={exportSMAMData}>
                          Export CSV
                        </button>
                      </div>
                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>Sr. No.</th>
                              <th>State</th>
                              <th>Count</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {smamChcDetails && smamChcDetails.length > 0 ? (
                              smamChcDetails.map((smam, index) => (
                                <React.Fragment key={index}>
                                  <tr>
                                    <td>{index + 1}</td>
                                    <td>{smam.stateName || 'N/A'}</td>
                                    <td>{smam.total || 0}</td>
                                    <td>
                                      <span 
                                        role="button"
                                        onClick={() => handleSMAMCHCDistrictToggle(index, smam)}
                                        style={{
                                          cursor: "pointer",
                                          color: "#0d6efd",
                                          fontSize: "12px",
                                          fontWeight: "bold"
                                        }}
                                        title="Click for district-wise details"
                                      >
                                        {expandedSmamChcStateIndex === index ? "-" : "+"}
                                      </span>
                                    </td>
                                  </tr>
                                  {expandedSmamChcStateIndex === index && expandedSmamChcDistrictData.length > 0 && (
                                    <tr>
                                      <td colSpan={4}>
                                        <div className="ms-4">
                                          <h6 className="mb-2">District-wise SMAM CHC Details for {smam.stateName}</h6>
                                          <div>
                                            <div className="d-flex justify-content-end mb-2">
                                              <button className="btn btn-sm btn-success" onClick={exportExpandedSmamChcDistrictData}>
                                                Export CSV
                                              </button>
                                            </div>
                                            <div className="table-responsive">
                                              <table className="table table-sm table-bordered">
                                                <thead>
                                                  <tr>
                                                    <th>Sr. No.</th>
                                                    <th>District</th>
                                                    <th>Count</th>
                                                  </tr>
                                                </thead>
                                              <tbody>
                                                {expandedSmamChcDistrictData.map((districtItem, districtIdx) => (
                                                  <tr key={districtIdx}>
                                                    <td>{districtIdx + 1}</td>
                                                    <td>{districtItem.districtNames || 'N/A'}</td>
                                                    <td>{districtItem.total || 0}</td>
                                                  </tr>
                                                ))}
                                              </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={4} className="text-center">No SMAM CHC data available</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {chcHistoryVisible && (
                <div className="col-lg-12" id="chc-history-table">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">CHC History Details</h5>
                      <div className="d-flex justify-content-end mb-2">
                        <button className="btn btn-sm btn-success" onClick={exportCHCHistoryData}>
                          Export CSV
                        </button>
                      </div>
                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>Sr. No.</th>
                              <th>CHC Name</th>
                              {/* <th>Location</th> */}
                              <th>State</th>
                              <th>District</th>
                              <th>Village</th>
                             
                              {/* <th>Created Date</th> */}
                              {/* <th>Status</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {chcHistoryDetails && chcHistoryDetails.length > 0 ? (
                              chcHistoryDetails.map((chc, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{chc.chcName || 'N/A'}</td>
                                  {/* <td>{chc.location || chc.address || 'N/A'}</td> */}
                                  <td>{chc.stateName || 'N/A'}</td>
                                  <td>{chc.districtName || 'N/A'}</td>
                                  <td>{chc.villageName || 'N/A'}</td>
                                  
                                  {/* <td>{chc.createdDate ? new Date(chc.createdDate).toLocaleDateString() : 'N/A'}</td>
                                  <td>{chc.isActive === 'Y' ? 'Active' : 'Inactive'}</td> */}
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={8} className="text-center">No CHC history data available</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {farmerVisible && (
                <div className="col-lg-12" id="farmer-details-table">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Farmer Registration Details</h5>
                      <div className="d-flex justify-content-end mb-2">
                        <button className="btn btn-sm btn-success" onClick={exportFarmerData}>
                          Export CSV
                        </button>
                      </div>
                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>Sr. No.</th>
                              {/* <th>Farmer Name</th>
                              <th>Mobile</th> */}
                              <th>State</th>
                              <th>District</th>
                              <th>Village</th>
                              {/* <th>Registration Date</th>
                              <th>Status</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {farmerDetails && farmerDetails.length > 0 ? (
                              farmerDetails.map((farmer, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  {/* <td>{farmer.farmerName || 'N/A'}</td>
                                  <td>{farmer.mobileNo || farmer.mobile || 'N/A'}</td> */}
                                  <td>{farmer.stateName || 'N/A'}</td>
                                  <td>{farmer.districtName || 'N/A'}</td>
                                  <td>{farmer.villageName || 'N/A'}</td>
                                  {/* <td>{farmer.registrationDate ? new Date(farmer.registrationDate).toLocaleDateString() : 'N/A'}</td>
                                  <td>{farmer.isActive === 'Y' ? 'Active' : 'Inactive'}</td> */}
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={8} className="text-center">No farmer registration data available</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {surveyorCreationVisible && (
                <div className="col-lg-12" id="surveyor-creation-table">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Surveyor Creation Details</h5>
                      <div className="d-flex justify-content-end mb-2">
                        <button className="btn btn-sm btn-success" onClick={exportSurveyorCreationData}>
                          Export CSV
                        </button>
                      </div>
                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>Sr. No.</th>
                              <th>District Name</th>
                              <th>User Count</th>
                             <th style={{width: "50px", textAlign: "center"}}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {surveyorCreationDetails && surveyorCreationDetails.length > 0 ? (
                              surveyorCreationDetails.map((district, index) => (
                                <React.Fragment key={index}>
                                  <tr>
                                    <td>{index + 1}</td>
                                    <td>{district.districtName || 'N/A'}</td>
                                    <td>{district.totalUsers || 0}</td>
                                 <td style={{textAlign: "center"}}>
                                      <span 
                                        role="button"
                                        onClick={() => handleSurveyorToggle(index, district)}
                                        style={{
                                          cursor: "pointer",
                                          color: "#0d6efd",
                                          fontSize: "16px",
                                          fontWeight: "bold"
                                        }}
                                      >
                                        {expandedSurveyorIndex === index ? "-" : "+"}
                                      </span>
                                    </td>
                                  </tr>
                                  
                                  {/* Expanded row content - Surveyor details */}
                                  {expandedSurveyorIndex === index && expandedSurveyorData && expandedSurveyorData.length > 0 && (
                                    <tr>
                                      <td colSpan={4}>
                                        <div className="mt-2 p-3 bg-light">
                                          <h6 className="mb-3">Surveyor Details for {district.districtName}:</h6>
                                          
                                          <div className="d-flex justify-content-end mb-2">
                                            <button className="btn btn-sm btn-success" onClick={() => exportSurveyorDetailsData()}>
                                              Export CSV
                                            </button>
                                          </div>
                                          
                                          <div className="table-responsive">
                                            <table className="table table-sm table-bordered mb-0">
                                              <thead>
                                                <tr>
                                                  <th>Sr. No.</th>
                                                   <th>User Name</th>
                                                  <th>State Name</th>
                                                  <th>District Name</th> 
                                                
                                                 
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {expandedSurveyorData.map((surveyor, surveyorIdx) => (
                                                  <tr key={surveyorIdx}>
                                                    <td>{surveyorIdx + 1}</td>
                                                     <td>{surveyor.userName || 'N/A'}</td>
                                                    <td>{surveyor.stateName || 'N/A'}</td>
                                                    <td>{surveyor.districtName || 'N/A'}</td> 
                                                    
                                                    
                                                  </tr>
                                                ))}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={4} className="text-center">No surveyor creation data available</td>
                                </tr>
                              )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {crmDemoVisible && (
                <div className="col-lg-12" id="crm-demo-table">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Machine Demonstration (CRM) - Farmer Details</h5>
                      <div className="d-flex justify-content-end mb-2">
                        <button className="btn btn-sm btn-success" onClick={exportCRMDemoFarmerData}>
                          Export CSV
                        </button>
                      </div>
                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>Sr. No.</th>
                              <th>Farmer Name</th>
                             
                              <th>Mobile No</th>
                              <th>State</th>
                              <th>District</th>
                              <th>Village</th>
                              
                            </tr>
                          </thead>
                          <tbody>
                            {crmDemoDetails && crmDemoDetails.length > 0 ? (
                              crmDemoDetails.map((farmer, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{farmer.farmerName || 'N/A'}</td>
                                
                                  <td>{farmer.mobileNo || 'N/A'}</td>
                                  <td>{farmer.stateName || 'N/A'}</td>
                                  <td>{farmer.districtName || 'N/A'}</td>
                                  <td>{farmer.villageName || 'N/A'}</td>
                                  
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={10} className="text-center">No farmer data available</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {smamChcVisible && (
                <div className="col-lg-12" id="smam-chc-details-table">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">SMAM CHC Survey Details</h5>
                      <div className="d-flex justify-content-end mb-2">
                        <button className="btn btn-sm btn-success" onClick={() => exportToCSV(smamChcDetails, "SMAM_CHC_Survey_Report", ["S.No", "State Name", "No of Users"])}>
                          Export CSV
                        </button>
                      </div>
                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>Sr. No.</th>
                              
                              <th>State</th>
                              <th>Count</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {smamChcDetails && smamChcDetails.length > 0 ? (
                              smamChcDetails.map((chc, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  
                                  <td>{chc.stateName || 'N/A'}</td>
                                  <td>{chc.chcCount || 'N/A'}</td>
                                  <td>
                                    <span 
                                      role="button"
                                      onClick={() => handleSMAMCHCDistrictToggle(index, chc)}
                                      style={{
                                        cursor: "pointer",
                                        color: "#0d6efd",
                                        fontSize: "12px",
                                        fontWeight: "bold"
                                      }}
                                      title="Click for district-wise details"
                                    >
                                      {expandedSmamChcStateIndex === index ? "-" : "+"}
                                    </span>
                                  </td>     
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={7} className="text-center">No SMAM CHC survey data available</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {crmChcVisible && (
                <div className="col-lg-12" id="crm-chc-details-table">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">CRM CHC Survey Details</h5>
                      <div className="d-flex justify-content-end mb-2">
                        <button className="btn btn-sm btn-success" onClick={() => exportToCSV(crmChcDetails, "CRM_CHC_Survey_Report", ["S.No", "State Name", "No of Users"])}>
                          Export CSV
                        </button>
                      </div>
                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>Sr. No.</th>
                              <th>State</th>
                              <th>Count</th>
                              <th>Action</th>
                              
                            </tr>
                          </thead>
                          <tbody>
                            {crmChcDetails && crmChcDetails.length > 0 ? (
                              crmChcDetails.map((chc, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  
                                  <td>{chc.stateName || 'N/A'}</td>
                                  <td>{chc.total}</td>
                                  <td>
                                    <span 
                                      role="button"
                                      onClick={() => handleCHCDistrictToggle(index, chc)}
                                      style={{
                                        cursor: "pointer",
                                        color: "#0d6efd",
                                        fontSize: "12px",
                                        fontWeight: "bold"
                                      }}
                                      title="Click for district-wise details"
                                    >
                                      {expandedChcStateIndex === index ? "-" : "+"}
                                    </span>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={7} className="text-center">No CRM CHC survey data available</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {role7Visible && (
                <div className="col-lg-12" id="role7-details-table">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">FMTTI Surveyor Details</h5>
                      <div className="d-flex justify-content-end mb-2">
                        <button className="btn btn-sm btn-success" onClick={() => exportToCSV(role7Details, "FMTTI_Surveyor_Report", ["S.No", "Name", "Count"])}>
                          Export CSV
                        </button>
                      </div>
                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>Sr. No.</th>
                              <th>Name</th>
                              <th>Count</th>
                            </tr>
                          </thead>
                          <tbody>
                            {role7Details && role7Details.length > 0 ? (
                              role7Details.map((item, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{item.name || item.stateName || item.districtName || item.userName || 'N/A'}</td>
                                  <td>{item.count || item.total || item.totalUsers || 0}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={3} className="text-center">
                                  {loading ? 'Loading...' : 'No surveyor data available'}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className='activebox'>
<div className="col-md-12">
  <div className="row">
    {/* <div className='col-md-3'>
    <div className='box1'>dasz</div>
    </div>

    <div className='col-md-3'>
    <div className='box1'>dasz</div>
    </div>

    <div className='col-md-3'>
    <div className='box1'>dasz</div>
    </div>

    <div className='col-md-3'>
    <div className='box1'>dasz</div>
    </div> */}




   
  </div>
{/*
  <div class="row">
						<div class="col-lg-3">
							<div class="box1">
								<div className='row'>
                  <div className='col-md-6'>
                    <h2>State</h2>
                  </div>
                  <div className='col-md-6 text-end'>
                 <span>1234</span>
                  </div>

                  <div className='col-md-12'>
                    <div className='view'>
                    <button className='btnview'>View Details</button>
                  </div></div>

                </div>
								
								
							</div>
						</div>
						
						<div class="col-lg-3">
							<div class="panel box2">
								<div class="panel-body">
									<div class="row">
										<div class="col-xs-3">
											<i class="fa fa-user fa-5x"></i>
										</div>
										<div class="col-xs-9 text-right">
											<div class="huge">
												<br/>78
											</div>
											<div>No of Member</div>
										</div>
									</div>
								</div>
								<a href="view/orders">
									<div class="panel-footer">
										<span class="pull-left">View Details</span>
										<span class="pull-right"><i class="fa fa-arrow-circle-right"></i></span>
										<div class="clearfix"></div>
									</div>
								</a>
							</div>
						</div>
						
						<div class="col-lg-3">
							<div class="panel box3">
								<div class="panel-body">
									<div class="row">
										<div class="col-xs-3">
											<i class="fa fa-inr fa-5x"></i>
										</div>
										<div class="col-xs-9 text-right">
											<div class="huge">
												<br/>12000
											</div>
											<div>Maintenance Of Month</div>
										</div>
									</div>
								</div>
								<a href="view/orders">
									<div class="panel-footer">
										<span class="pull-left">View Details</span>
										<span class="pull-right"><i class="fa fa-arrow-circle-right"></i></span>
										<div class="clearfix"></div>
									</div>
								</a>
							</div>
						</div>
						
						 <div class="col-lg-3" style={Visibility === "hidden" ? { display: "none" } : {}}>
							<div class="panel box4">
								<div class="panel-body">
									<div class="row">
										<div class="col-xs-3">
											<i class="fa fa-tasks fa-5x"></i>
										</div>
										<div class="col-xs-9 text-right">
											<div class="huge">
												<br/>07
											</div>
											<div>Pending Complain</div>
										</div>
									</div>
								</div>
								<a href="view/orders">
									<div class="panel-footer">
										<span class="pull-left">View Details</span>
										<span class="pull-right"><i class="fa fa-arrow-circle-right"></i></span>
										<div class="clearfix"></div>
									</div>
								</a>
							</div>
						</div> 
					</div>
*/}


</div>
</div>

        </section>
      </main>
      <AdminFooterNew />
    </>

  )

}

export default DashboardMnT;